/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Response model for the alive/health check endpoint */
export interface AliveResponse {
  /**
   * Current server date and time
   * @format date-time
   */
  date?: string;
  /** Server version */
  version?: string;
  /** Server status */
  status?: string;
}

/**
 * Represents the data structure for a file type, including host system info
 * and the latest file per host system (without matching files).
 */
export interface GetFileTypeLatestHostSystemFileData {
  /**
   * Gets or sets the unique identifier for the file type.
   * @format guid
   * @minLength 1
   */
  id: string;
  /**
   * Gets or sets the name of the file type.
   * @minLength 1
   */
  name: string;
  /** Value is shown on public endpoints */
  public: boolean;
  /** File Type Class for filtering */
  type: FileTypeClass;
  /**
   * Latest files per host system (only entries with a file).
   *
   */
  latestFiles?: LatestHostSystemFileDto[];
  /**
   * Package identifier (used primarily for Android or iOS license generation).
   *
   */
  packageId?: string | null;
  /**
   * Gets or sets the unique identifier for the icon.
   * @format guid
   */
  iconId?: string | null;
  /** Gets or sets the unique identifiers for screenshots. */
  screenshotIds?: string[];
}

/** FileType Class - For display purposes */
export enum FileTypeClass {
  UNDEFINED = "UNDEFINED",
  APPLICATION = "APPLICATION",
  DOCUMENTATION = "DOCUMENTATION",
  OTHER = "OTHER",
}

/**
 * Latest file info for a host system (flattened).
 *
 */
export interface LatestHostSystemFileDto {
  /**
   * The HostSystem ID this file is for.
   *
   * @format guid
   */
  hostSystemId?: string;
  /**
   * The HostSystem name this file is for.
   *
   */
  hostSystemName?: string;
  /**
   * Indicates if this HostSystem is used for documentation
   *
   */
  isDocumentation?: boolean;
  /**
   * File identifier.
   *
   */
  fileId?: string | null;
  /**
   * Version key without product id.
   *
   */
  versionKey?: LatestVersionKey | null;
  /**
   * Version stage (e.g., BETA, RELEASE).
   *
   */
  stage?: EVersionStage;
}

/**
 * Version key without product id.
 *
 */
export interface LatestVersionKey {
  /**
   * The major version number.
   * @format int32
   */
  major?: number;
  /**
   * The minor version number.
   * @format int32
   */
  minor?: number;
  /**
   * The patch version number.
   * @format int32
   */
  patch?: number;
}

/**
 * Version Stage
 *
 */
export enum EVersionStage {
  INTERNAL = 0,
  ALPHA = 1,
  BETA = 2,
  RELEASE_CANDIDATE = 3,
  RELEASE = 4,
  APPROVED = 5,
}

/** Filter for documentation HostSystems */
export enum DocumentationFilter {
  All = "All",
  OnlyDocumentation = "OnlyDocumentation",
  ExcludeDocumentation = "ExcludeDocumentation",
}

/**
 * Represents the data structure for a file type, including associated host system,
 * matching files, and filter tags.
 */
export interface GetFileTypeData {
  /**
   * Gets or sets the unique identifier for the file type.
   * @format guid
   * @minLength 1
   */
  id: string;
  /**
   * Gets or sets the name of the file type.
   * @minLength 1
   */
  name: string;
  /** Value is shown on public endpoints */
  public: boolean;
  /** File Type Class for filtering */
  type: FileTypeClass;
  /**
   * Gets or sets the description of the file type.
   * Provides additional information about its purpose or usage.
   */
  description?: string;
  /**
   * Platform-specific configurations for this FileType.
   * Each entry links the FileType to a HostSystem with platform-specific MatchingFiles.
   *
   */
  platformConfigurations?: FileTypePlatformConfigurationDto[];
  /**
   * Package identifier (used primarily for Android or iOS license generation).
   *
   */
  packageId?: string | null;
  /** Version used for creating the License Key */
  version?: number;
  /** File type variants for the current file type (empty list: only Default) */
  variants?: FileTypeVariantsDto[];
  /**
   * Gets or sets a list of filter tags used for the current host system.
   * These tags help categorize or identify the file type for filtering or searching.
   */
  filterTags?: GetFilterTagData[];
  /** Gets or sets the list of related file type IDs. */
  relatedFileTypeIds?: string[];
  /**
   * Gets or sets the unique identifier for the icon.
   * @format guid
   */
  iconId?: string | null;
  /** Gets or sets the unique identifier for the icon. */
  screenshotIds?: string[];
}

/**
 * Platform-specific configuration for a FileType-HostSystem relationship.
 *
 */
export interface FileTypePlatformConfigurationDto {
  /**
   * The HostSystem ID this configuration is for.
   *
   * @format guid
   */
  hostSystemId?: string;
  /**
   * The HostSystem name this configuration is for.
   *
   */
  hostSystemName?: string;
  /**
   * Platform-specific matching file patterns.
   *
   */
  matchingFiles?: string[] | null;
}

export interface FileTypeVariantsDto {
  tag?: string;
  name?: string;
}

/**
 * HTTP return value for filter tags
 *
 */
export interface GetFilterTagData {
  /**
   * Individual identifier of the filter tag. Will be set by user
   *
   * @example "con_BosCompact"
   */
  identifier?: string;
  /**
   * Custom name to describe filter tag
   *
   * @example "BosCompact"
   */
  name?: string;
}

export interface GetVersionFileData {
  id?: string;
  /** Represents the version key of a product. */
  versionKey?: VersionKey;
  fileName?: string;
  /**
   * Represents the data structure for a file type, including associated host system,
   * matching files, and filter tags.
   */
  fileType?: GetFileTypeData;
  /**
   * HostSystem/Platform for this file (Windows, Android, iOS, etc.)
   * @format guid
   */
  hostSystemId?: string | null;
  /** HostSystem/Platform name */
  hostSystemName?: string | null;
  /** User can download this file */
  canDownload?: boolean;
}

/** Represents the version key of a product. */
export interface VersionKey {
  /**
   * The major version number.
   * @format int32
   * @example 3
   */
  major?: number;
  /**
   * The minor version number.
   * @format int32
   * @example 1
   */
  minor?: number;
  /**
   * The patch version number.
   * @format int32
   * @example 0
   */
  patch?: number;
  /**
   * The unique identifier for the product.
   * @format guid
   * @example "3D290374-8689-4856-B5C4-35E0414F66E8"
   */
  productId?: string;
}

export interface ImageDto {
  /** @format guid */
  id?: string;
  fileName?: string;
  contentType?: string;
  description?: string;
}

/** Model for device registration using a license code. */
export interface RegisterDeviceModel {
  /** Name of the device. */
  name?: string;
  /** License code provided by administrator. */
  licenseCode?: string;
  /** Optional device hardware identifier. */
  deviceId?: string | null;
  /** Operating system version (e.g., "Android 14", "iOS 17"). */
  osVersion?: string;
}

/**
 * AppStore configuration data transfer object.
 *
 */
export interface AppStoreConfigDto {
  /**
   * Indicates whether the AppStore FileType ID is configured.
   *
   */
  configured?: boolean;
  /**
   * The configured FileType ID for the AppStore APK.
   *
   * @format guid
   */
  fileTypeId?: string | null;
  /**
   * Optional message (e.g., success or error message).
   *
   */
  message?: string | null;
}

/**
 * AppStore APK information data transfer object.
 *
 */
export interface AppStoreInfoDto {
  /**
   * Indicates whether the AppStore APK is available.
   *
   */
  available?: boolean;
  /**
   * Name of the file type.
   *
   */
  fileTypeName?: string | null;
  /**
   * Version string (e.g., "1.2.3").
   *
   */
  version?: string | null;
  /**
   * Version ID.
   *
   */
  versionId?: string | null;
  /**
   * File name of the APK.
   *
   */
  fileName?: string | null;
  /**
   * Optional message (e.g., error message when not available).
   *
   */
  message?: string | null;
}

/** Persisted audit entry for device/license related operations. */
export interface AuditLogEntry {
  /**
   * Primary key of the audit entry.
   * @format guid
   */
  id?: string;
  /**
   * UTC timestamp when the event was recorded.
   * @format date-time
   */
  timestamp?: string;
  /** User identifier (usually email) that triggered the action. */
  user?: string | null;
  /** Logical domain of the reference, e.g. Device, License, SupportContract. */
  referenceType?: string;
  /** Identifier of the referenced entity. String to support Guid and non-Guid IDs. */
  referenceId?: string;
  /** Technical function/action name, e.g. Register, Delete, AssignSupportCode. */
  function?: string;
  /** Human-readable audit message. */
  message?: string;
  /** Optional additional details in free text format. */
  details?: string | null;
  /** Client IP address from which the action originated. */
  clientIp?: string | null;
  /** User-Agent header of the client request. */
  userAgent?: string | null;
}

/**
 * Dashboard statistics response.
 *
 */
export interface DashboardStatisticsDto {
  /**
   * Number of active support contracts.
   *
   * @format int32
   */
  activeContracts?: number;
  /**
   * Number of support contracts expiring soon.
   *
   * @format int32
   */
  expiringSoonContracts?: number;
  /**
   * Number of expired support contracts.
   *
   * @format int32
   */
  expiredContracts?: number;
  /**
   * Number of open tickets.
   *
   * @format int32
   */
  openTickets?: number;
  /**
   * Number of recent versions in the selected time window.
   *
   * @format int32
   */
  recentVersionsCount?: number;
  /**
   * Total number of available downloads.
   *
   * @format int32
   */
  availableDownloads?: number;
  /**
   * Number of available version files.
   *
   * @format int32
   */
  availableVersionDownloads?: number;
  /**
   * Number of available shared files.
   *
   * @format int32
   */
  availableSharedFiles?: number;
  /**
   * List of recently uploaded versions.
   *
   */
  recentVersions?: RecentVersionDto[];
}

/**
 * Compact version information for recent version lists.
 *
 */
export interface RecentVersionDto {
  /**
   * Version ID as computed string.
   *
   */
  versionId?: string;
  /**
   * Major version as number.
   *
   * @format int32
   */
  major?: number;
  /**
   * Minor version as number.
   *
   * @format int32
   */
  minor?: number;
  /**
   * Patch version as number.
   *
   * @format int32
   */
  patch?: number;
  /**
   * Subtitle of the version.
   *
   */
  subtitle?: string;
  /**
   * Date when the version was approved.
   *
   * @format date
   */
  approved?: string | null;
  /**
   * Date when the version entry was created.
   *
   * @format date-time
   */
  createdAt?: string;
  /**
   * Product ID connected to this version.
   *
   */
  productId?: string;
  /**
   * Product name connected to this version.
   *
   */
  productName?: string;
  /**
   * Version stage.
   *
   */
  stage?: EVersionStage;
  /**
   * Summary of critical update. If empty, version is not critical.
   *
   */
  criticalUpdate?: string | null;
}

/** DTO for device query responses. */
export interface DeviceQueryModel {
  /**
   * Gets or sets the unique identifier for the device query.
   * @format guid
   */
  id?: string;
  /** Gets or sets the device identifier (Hardware-ID / HostID). */
  deviceId?: string | null;
  /** Kundenseitige Geräte-ID (z.B. "Maschine-Halle-3"). */
  customerDeviceId?: string | null;
  /** True, wenn dem Gerät bereits eine Hardware-ID zugewiesen wurde. */
  hardwareIdAssigned?: boolean;
  /** Gets or sets the name of the device. */
  name?: string;
  /** Gets or sets the name of the host system. */
  hostSystemName?: string | null;
  /** Gets or sets the operating system version. */
  osVersion?: string | null;
  /** Gets or sets the support code. */
  supportCode?: string | null;
  /** Gets or sets the status of the device. */
  deviceStatus?: DeviceStatusEnum;
  /** License code used for device registration. */
  licenseCode?: string;
  /**
   * Months of updates assigned to this device.
   * @format int32
   */
  updatesMonths?: number;
  /**
   * Date when the device was registered. Used for automatic update calculation.
   * @format date-time
   */
  registrationDate?: string | null;
  /**
   * Calculated date when updates expire (RegistrationDate + UpdatesMonths).
   * @format date-time
   */
  updatesExpirationDate?: string | null;
  /** Whether updates are still valid (before expiration date). */
  updatesValid?: boolean;
  /**
   * Count of assigned active licenses.
   * @format int32
   */
  licenseCount?: number;
  /**
   * Bereits lizenzierte Service-Einheiten (Summe über alle aktiven/genehmigten Lizenzen).
   * @format decimal
   */
  licensedServiceEinheiten?: number;
  /**
   * Angefragte Service-Einheiten (Summe über alle offenen Lizenzanfragen mit Status "Draft" oder "Requested").
   * @format decimal
   */
  requestedServiceEinheiten?: number;
  /** Customer ID from the associated support contract. */
  customerId?: string | null;
  /** Customer name from the associated support contract. */
  customerName?: string | null;
}

/** Enum for the status of a device used for DeviceManagement */
export enum DeviceStatusEnum {
  Pending = "Pending",
  Active = "Active",
  Inactive = "Inactive",
  Deleted = "Deleted",
}

/** Model for changing device status. */
export interface SetDeviceStatusModel {
  /**
   * Internal device ID (Guid).
   * @format guid
   */
  deviceId?: string;
  /** New status to set. */
  newStatus?: DeviceStatusEnum;
}

/** Model for creating a new device. Customers use this for the order flow (without Hardware-ID). */
export interface CreateDeviceModel {
  /** Name of the device. */
  name?: string;
  /** Optional Hardware-ID / HostID. Customers must not set this at creation time. */
  deviceId?: string | null;
  /** Customer-side identifier (e.g. "Maschine-Halle-3"). Required for customer-initiated creation. */
  customerDeviceId?: string | null;
  /**
   * Host system ID for the device. Determines which apps are displayed.
   * @format guid
   */
  hostSystemId?: string;
  /**
   * Months of updates assigned to this device. Defaults to 12 if not specified.
   * @format int32
   */
  updatesMonths?: number | null;
  /** Support code ID to assign this device to. Required for customers. */
  supportCodeId?: string | null;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

/** Model for assigning a support code to a device. */
export interface AssignSupportCodeModel {
  /** Support code ID to assign to the device. */
  supportCodeId?: string;
}

/** Model for updating device host system */
export interface UpdateDeviceHostSystemModel {
  /**
   * The new host system ID
   * @format guid
   */
  hostSystemId?: string;
}

/** Request model for releasing the host-id binding from a device. */
export interface ReleaseHostIdModel {
  /** Optional reason text that is stored in the audit log. */
  reason?: string | null;
}

/** Request model for the one-time assignment of a Hardware-ID (HostID) to a pending (ordered) device. */
export interface AssignHostIdModel {
  /** Hardware-ID / HostID in format XXXX-XXXX-XXXX-XXXX-XXXX. */
  hostId: string;
}

/** Response für den XML-Upload */
export interface UploadLicenseXmlResponse {
  /** Erfolgsmeldung */
  message?: string;
  /**
   * Device ID
   * @format guid
   */
  deviceId?: string;
}

export interface CloneDeviceModel {
  newHostId?: string | null;
  newDeviceName?: string | null;
}

/**
 * Data Transfer Object for shared file information
 * Used for returning file information to clients
 */
export interface SharedFileDto {
  /**
   * Unique identifier of the file, used for storage and reference
   * @format guid
   * @minLength 1
   */
  id: string;
  /**
   * Display title of the file (custom title or original filename)
   * @minLength 1
   */
  title: string;
  /**
   * File extension including the dot (e.g., ".pdf", ".xml")
   * @minLength 1
   */
  fileExtension: string;
  /**
   * Size of the file in bytes
   * @format int64
   */
  fileSize: number;
  /**
   * MIME type of the file (e.g., "application/pdf")
   * @minLength 1
   */
  contentType: string;
  /** Indicates whether this is a configuration file (XML/JSON) */
  isConfigFile: boolean;
  /**
   * ID of the support contract this file belongs to
   * @format guid
   * @minLength 1
   */
  supportContractId: string;
  /**
   * ID of the user who created/uploaded the file
   * @format guid
   * @minLength 1
   */
  createdById: string;
  /**
   * Display name of the user who created/uploaded the file
   * Can be null in rare cases
   */
  createdByName?: string | null;
  /**
   * Timestamp when the file was created
   * @format date-time
   * @minLength 1
   */
  created: string;
  /**
   * Timestamp when the file was last modified
   * @format date-time
   * @minLength 1
   */
  modified: string;
  /**
   * Actual filename used in storage (UUID + extension)
   * @minLength 1
   */
  storageFileName: string;
}

/**
 * HTTP Return value for host system data
 *
 */
export interface GetHostSystemData {
  /**
   * Internal id of the host system
   *
   */
  id?: string;
  /**
   * Public name
   * BosCompakt
   *
   */
  name?: string;
  /**
   * Minimum OS Version
   *
   */
  minVersion?: string;
  /**
   * Maximum OS Version
   *
   */
  maxVersion?: string;
  /**
   * Short description (for internal use)
   *
   */
  description?: string;
  /**
   * List of used filter tags for current host system
   *
   */
  filterTags?: GetFilterTagData[];
  /** Custom id for internal usage */
  hostSystemCustomId?: string | null;
  /** Indicates if this HostSystem is used for documentation instead of a real platform */
  isDocumentation?: boolean;
}

export interface AddHostSystemData {
  name?: string;
  minVersion?: string;
  maxVersion?: string | null;
  description?: string;
  filterTags?: string[];
  /** Custom id for internal usage */
  hostSystemCustomId?: string | null;
  /** Indicates if this HostSystem is used for documentation instead of a real platform */
  isDocumentation?: boolean;
}

export interface AddFileTypeData {
  /**
   * Common name of the file type
   *
   */
  name?: string;
  /**
   * Description of the file type
   *
   */
  description?: string;
  /**
   * Used filter tags for current file
   *
   */
  filterTags?: string[];
  /**
   * Platform-specific configurations for this FileType.
   * Each entry links the FileType to a HostSystem with platform-specific MatchingFiles.
   *
   */
  platformConfigurations?: AddFileTypePlatformConfigurationDto[];
  /**
   * Package identifier (used primarily for Android or iOS license generation).
   *
   */
  packageId?: string | null;
  /** Version used for creating the License Key */
  version?: number;
  /** File type variants for the current file type (empty list: only Default) */
  variants?: FileTypeVariantsDto[];
  /** File Type Class for filtering */
  type?: FileTypeClass;
  /** Value is shown on public endpoints */
  public?: boolean;
}

/**
 * DTO for adding a platform configuration to a FileType.
 *
 */
export interface AddFileTypePlatformConfigurationDto {
  /**
   * The HostSystem ID this configuration is for.
   *
   * @format guid
   */
  hostSystemId?: string;
  /**
   * Platform-specific matching file patterns.
   *
   */
  matchingFiles?: string[] | null;
}

/**
 * Represents a Bad Request Response.
 *
 */
export interface BadRequestResponse {
  /**
   * The HTTP Status code of the bad request.
   *
   * @format int32
   * @example 400
   */
  statusCode?: number;
  /**
   * Custom defined error message.
   *
   * @example "Invalid access rights"
   */
  message?: string;
  /**
   * Stack trace of the error if provided.
   *
   */
  stackTrace?: string | null;
}

/**
 * HTTP Post data to add new filter tag
 *
 */
export interface AddFilterTagData {
  /**
   * Individual identifier of the filter tag. Will be set by user
   *
   * @example "con_BosCompact"
   */
  identifier?: string;
  /**
   * Custom name to describe filter tag
   *
   * @example "BosCompact"
   */
  name?: string;
}

export interface GdbServicePing {
  serviceName?: string;
  buildType?: string[];
  serverAddress?: string;
}

export interface GdbMiRecord {
  typeDiscriminator?: string;
}

export interface GetCoreDumpDTO {
  /**
   * Individual ID. Also filename on storage
   * Filename+Extension = Filename on Storage
   *
   * @format guid
   */
  id?: string;
  /**
   * The build number of the software.
   *
   * @format int32
   */
  buildId?: number;
  buildPipeline?: string;
  /**
   * Defines if the software is running in debug mode.
   *
   */
  debug?: boolean;
  /**
   * The OS name of the machine running the software.
   *
   */
  osName?: string;
  /**
   * The OS release of the machine running the software.
   *
   */
  osRelease?: string;
  /**
   * The platform the software is running on.
   *
   */
  platform?: string;
  /** Navigation property to the SupportCode */
  supportCode?: GetSupportCodeData | null;
  /**
   * The system name of the machine running the software.
   *
   */
  systemName?: string;
  /**
   * The version of the software.
   *
   */
  version?: GetVersionData | null;
  /**
   * Parameter if CoreDumpService sucessfully finished the coredump
   *
   * @format date-time
   */
  sucessfullyFinished?: string | null;
  /**
   * Parameter if CoreDumpService sucessfully finished the coredump
   *
   * @format date-time
   */
  created?: string | null;
  /** File deleted from storage */
  isDeletedFromStorage?: boolean;
  /**
   * Comment to the core dump by the service team
   *
   */
  serviceComment?: string;
  /** Error while handling GDB Data */
  error?: string | null;
  /** Not mapped colum to Serialize Metadata */
  metadata?: any;
}

/**
 * HTTP Return value for support code data
 *
 */
export interface GetSupportCodeData {
  /**
   * Support code id
   *
   */
  id?: string;
  /**
   * Date time when support code was created
   *
   * @format date-time
   */
  createdAt?: string;
  /**
   * Date time when support code was updated
   *
   * @format date-time
   */
  updatedAt?: string | null;
  /**
   * Support ID (will be generated by system)
   * AC3-B7Q
   *
   */
  supportId?: string;
  /**
   * Redirect url, where support code should redirect to
   *
   */
  redirectUrl?: string;
  /**
   * Name of the support code (can be used to describe the system)
   *
   */
  name?: string;
  /**
   * Generated url to generate QR code
   *
   *     https://support.reichert-gmbh.com/quicksupport?data=niubadifhb201823biadjbcoSDIUBF
   *
   *
   */
  customUrl?: string;
}

/**
 * HTTP GET of internal version data
 *
 */
export type GetVersionData = GetVersionDataCustomer & {
  /**
   * Internal information for office / development in company
   *
   */
  internalInformation?: string;
};

/**
 * HTTP GET of customer based version data
 *
 */
export type GetVersionDataCustomer = GetVersionDataPublic & {
  /**
   * Short description of the version
   *
   */
  description?: string;
  /** Header of version */
  header?: string | null;
  /** Footer of version */
  footer?: string | null;
  /**
   * Version stage. Used to display version stage in UI
   *
   */
  stage?: EVersionStage;
  /**
   * Summary of critical version. If empty current version is NOT a critical version.
   *
   */
  criticalUpdate?: string | null;
  /**
   * List of downloadable files
   *
   */
  files?: VersionVersionFileData[];
};

export interface VersionVersionFileData {
  id?: string;
  fileName?: string;
  /**
   * Represents the data structure for a file type, including associated host system,
   * matching files, and filter tags.
   */
  type?: GetFileTypeData;
  /**
   * HostSystem/Platform for this file (Windows, Android, iOS, etc.)
   * @format guid
   */
  hostSystemId?: string | null;
  /** HostSystem/Platform name */
  hostSystemName?: string | null;
  downloadedBy?: GetUserDataShort[];
}

/**
 * Short user data e.G. for list of users which downloaded a file
 *
 */
export interface GetUserDataShort {
  /**
   * UUID of the User
   *
   * @format guid
   */
  id?: string;
  /**
   * Email of the user
   *
   */
  name?: string;
  /**
   * Email of the user
   *
   */
  eMail?: string;
}

/**
 * HTTP GET of public version data
 *
 */
export interface GetVersionDataPublic {
  /**
   * Version ID as computed string.
   *
   */
  versionId?: string;
  /**
   * Major version as number
   *
   * @format int32
   */
  major?: number;
  /**
   * Minor version as number
   *
   * @format int32
   */
  minor?: number;
  /**
   * Patch version as number
   *
   * @format int32
   */
  patch?: number;
  /**
   * Subtitle of the version (first line to describe content)
   *
   */
  subtitle?: string;
  /**
   * Version changes as object
   *
   */
  changes?: VersionChanges;
  /**
   * DateTime when version was approved
   *
   * @format date
   */
  approved?: string | null;
  /** Cild versions of the current version. Can also be null */
  childVersions?: GetVersionData[] | null;
  /** Id of product connected to this version */
  productId?: string;
}

/**
 * Version changes structure for storage as JSON in Databaseö
 *
 */
export interface VersionChanges {
  /**
   * List of bugfixes as list of strings
   *
   */
  bugfixes?: string[];
  /**
   * List of features as list of strings
   *
   */
  features?: string[];
  /**
   * List of highlights as list of strings
   *
   */
  highlights?: string[];
}

/** Response-Modell für Host-ID Informationen */
export interface HostIdResponse {
  /** Die vollständige Host-ID (24 Zeichen) */
  hostid?: string;
  /** Ob die Checksumme gültig ist */
  checksum_valid?: boolean;
  /**
   * Das Checksummen-Byte
   * @format int32
   */
  checksum_byte?: number;
  /**
   * OS-Typ ID (0=Linux, 1=Windows, 2=macOS, 3=iOS, 4=Android)
   * @format int32
   */
  os_type_id?: number;
  /** OS-Typ als lesbarer String */
  os_type?: string;
  /**
   * Identifier-Quellen ID (0=System UUID, 1=Ethernet MAC, 2=WiFi MAC, 3=Other MAC, 4=Generated Token)
   * @format int32
   */
  identifier_source_id?: number;
  /** Identifier-Quelle als lesbarer String */
  identifier_source?: string;
  /**
   * Ausführungskontext ID (0=Real Hardware, 1=Virtual Machine, 2=Container)
   * @format int32
   */
  execution_context_id?: number;
  /** Ausführungskontext als lesbarer String */
  execution_context?: string;
}

/** Response-Modell für Bibliotheksversion */
export interface HostIdVersionResponse {
  /** Ob die Bibliothek verfügbar ist */
  available?: boolean;
  /** Version der Bibliothek */
  version?: string;
}

/** Response für generierte Lizenzdatei */
export interface LicenseFileResponse {
  /** Lizenz als Base64-String */
  licenseString?: string;
  /** Vorgeschlagener Dateiname */
  fileName?: string;
  /**
   * Größe in Zeichen
   * @format int32
   */
  estimatedSize?: number;
}

/**
 * Kompakte Lizenz-Datenstruktur für QR-Code-kompatible Lizenzdateien.
 * Verwendet kurze Property-Namen für minimale JSON-Größe.
 */
export interface LicenseData {
  /** Lizenz-ID (kurz: "id") */
  id?: string;
  /** Name des Lizenznehmers (kurz: "n") */
  n?: string;
  /** Hardware-ID / Device-ID (kurz: "hw") - Bindet Lizenz an spezifische Hardware (REQUIRED) */
  hw?: string;
  /**
   * Ausstellungsdatum (kurz: "iss") - Unix Timestamp
   * @format int64
   */
  iss?: number;
  /** Module/Features mit individuellen Einstellungen (kurz: "m") */
  m?: LicenseModule[];
  /** Zusätzliche kompakte Metadaten (kurz: "x") */
  x?: Record<string, string>;
}

/**
 * Flexibles Lizenz-Modul mit dynamischen Properties.
 * Kurze Property-Namen für minimale JSON-Größe.
 * Jedes Modul kann seine eigenen spezifischen Daten in "data" speichern.
 */
export interface LicenseModule {
  /**
   * Modul-Code (kurz: "c") - z.B. "core", "analytics", "debug", "product_xyz"
   * Definiert den Typ des Moduls und dessen Struktur
   */
  c?: string;
  /**
   * Ablaufdatum (kurz: "exp") - Unix Timestamp, null = unbegrenzt
   * @format int64
   */
  exp?: number | null;
  /**
   * Dynamische Modul-Daten (kurz: "d") - Flexibles Dictionary für modul-spezifische Daten
   * z.B. für Produkt-Modul: {"product": "S6", "version": "2.0"}
   * z.B. für Feature-Modul: {"features": "api,export,cloud"}
   * z.B. für Debug-Modul: {"debuggers": "gdb,lldb", "remote": "true"}
   * Native AOT-kompatibel durch Verwendung von JsonElement
   */
  d?: Record<string, any>;
}

/** Response-Modell für die Lizenz-Inspektion */
export interface LicenseInspectionResponse {
  /** True, wenn die Signatur gültig ist */
  signatureValid?: boolean;
  /** True, wenn Lizenzdaten geparsed wurden */
  parsed?: boolean;
  /** Lizenzdaten (falls parsebar) */
  licenseData?: LicenseData | null;
  /** Rohes JSON der Lizenz (falls dekodierbar) */
  rawJson?: string | null;
  /** Fehlertext (falls vorhanden) */
  error?: string | null;
}

/** Request-Modell für die Lizenzvalidierung */
export interface ValidateLicenseRequest {
  /** Lizenz als Base64-String */
  licenseString?: string;
}

/** DTO für LicenseOption ohne Navigation Properties (vermeidet zirkuläre Referenzen) */
export interface LicenseOptionDto {
  /**
   * LicenseOption ID
   * @format guid
   */
  id?: string;
  /** Technischer Identifier */
  identifier?: string;
  /** Anzeigename */
  commonName?: string;
  /** Optionale Beschreibung */
  description?: string | null;
  /** Datentyp der Option */
  type?: LicenseOptionType;
  /** Aggregations-Modus für Number-Optionen */
  aggregationMode?: LicenseOptionAggregationMode;
  /** Standardwert als JSON-String */
  defaultValue?: string | null;
  /**
   * Sortierung für UI
   * @format int32
   */
  displayOrder?: number;
  /** Aktiv-Status der Option */
  isActive?: boolean;
  /** Ist die Option für Kunden sichtbar? */
  isVisibleToCustomer?: boolean;
}

/** Typ der Lizenz-Option */
export enum LicenseOptionType {
  Number = 0,
  Boolean = 1,
  String = 2,
  Date = 3,
}

/** Aggregations-Modus für Number-Optionen bei mehreren Lizenzen */
export enum LicenseOptionAggregationMode {
  None = 0,
  Sum = 1,
  Max = 2,
}

/** Response-Modell für die Verwendung einer LicenseOption */
export interface LicenseOptionUsageResponse {
  /**
   * LicenseOption ID
   * @format guid
   */
  optionId?: string;
  /** Identifier der Option */
  identifier?: string;
  /** Anzeigename der Option */
  commonName?: string;
  /**
   * Anzahl der verwendenden FileTypes
   * @format int32
   */
  usageCount?: number;
  /** Liste der FileTypes die diese Option verwenden */
  usedByFileTypes?: FileTypeUsageInfo[];
}

/** Info über die Verwendung in einem FileType */
export interface FileTypeUsageInfo {
  /**
   * FileType ID
   * @format guid
   */
  fileTypeId?: string;
  /** FileType Name */
  fileTypeName?: string;
  /** Ist diese Option für diesen FileType verpflichtend? */
  isRequired?: boolean;
  /** FileType-spezifischer Default-Wert */
  fileTypeSpecificDefault?: string | null;
  /**
   * Service-Einheiten für diese Option innerhalb des FileTypes
   * @format int32
   */
  serviceEinheiten?: number | null;
}

/** Request-Modell für die Erstellung einer LicenseOption */
export interface CreateLicenseOptionRequest {
  /** Technischer Identifier der Option */
  identifier?: string;
  /** Anzeigename der Option */
  commonName?: string;
  /** Optionale Beschreibung */
  description?: string | null;
  /** Datentyp der Option */
  type?: LicenseOptionType;
  /** Aggregations-Modus für Number-Optionen */
  aggregationMode?: LicenseOptionAggregationMode;
  /** Standardwert als JSON-String */
  defaultValue?: string | null;
  /**
   * Sortierung für UI
   * @format int32
   */
  displayOrder?: number;
  /** Aktiv-Status der Option */
  isActive?: boolean;
  /** Ist die Option für Kunden sichtbar? */
  isVisibleToCustomer?: boolean;
}

/** Response-Modell für FileTypeLicenseOption mit LicenseOption Details (ohne zirkuläre Referenzen) */
export interface FileTypeLicenseOptionResponse {
  /**
   * FileTypeLicenseOption ID
   * @format guid
   */
  id?: string;
  /**
   * FileType ID
   * @format guid
   */
  fileTypeId?: string;
  /**
   * LicenseOption ID
   * @format guid
   */
  licenseOptionId?: string;
  /** Ist die Option verpflichtend? */
  isRequired?: boolean;
  /** Dateityp-spezifischer Standardwert */
  fileTypeSpecificDefault?: string | null;
  /**
   * Service-Einheiten für diese Option innerhalb des FileTypes
   * @format int32
   */
  serviceEinheiten?: number | null;
  /** LicenseOption Details */
  licenseOption?: LicenseOptionDto | null;
}

/** Request-Modell für das Hinzufügen einer LicenseOption zu einem FileType */
export interface AddLicenseOptionToFileTypeRequest {
  /**
   * LicenseOption ID
   * @format guid
   */
  licenseOptionId?: string;
  /** Ob die Option verpflichtend ist */
  isRequired?: boolean;
  /** Dateityp-spezifischer Standardwert als JSON-String */
  fileTypeSpecificDefault?: string | null;
  /**
   * Service-Einheiten für diese Option innerhalb des FileTypes
   * @format int32
   */
  serviceEinheiten?: number | null;
}

/** Request-Modell für die Aktualisierung einer FileType-LicenseOption */
export interface UpdateFileTypeLicenseOptionRequest {
  /** Ob die Option verpflichtend ist */
  isRequired?: boolean;
  /** Dateityp-spezifischer Standardwert als JSON-String */
  fileTypeSpecificDefault?: string | null;
  /**
   * Service-Einheiten für diese Option innerhalb des FileTypes
   * @format int32
   */
  serviceEinheiten?: number | null;
}

/** Response-Modell für FileTypeLicense */
export interface FileTypeLicenseResponse {
  /**
   * Lizenz-ID
   * @format guid
   */
  id?: string;
  /**
   * FileType ID
   * @format guid
   */
  fileTypeId?: string;
  /** FileType Name */
  fileTypeName?: string;
  /**
   * Device ID
   * @format guid
   */
  deviceId?: string;
  /** Device Name */
  deviceName?: string;
  /** Hardware-Id des Devices */
  deviceHardwareId?: string | null;
  /** Support Code ID des Devices */
  supportCode?: string | null;
  /** Kunden-ID aus dem Support Contract */
  customerId?: string | null;
  /** Kundenname aus dem Support Contract */
  customerName?: string | null;
  /** Signierte Lizenzdatei (Base64) */
  signedLicenseString?: string | null;
  /** Status der Lizenz */
  status?: FileTypeLicenseStatus;
  /**
   * Ausstellungsdatum
   * @format date-time
   */
  issuedAt?: string;
  /**
   * Ablaufdatum (optional)
   * @format date-time
   */
  expiresAt?: string | null;
  /** Notizen zur Lizenz */
  notes?: string | null;
  /** Lizenzdaten (dekodiert) */
  licenseData?: LicenseData | null;
  /** Benutzer der die Lizenz eingereicht hat */
  requestedBy?: GetUserDataShort | null;
  /** Benutzer der die Lizenz genehmigt hat (nur für Office) */
  approvedBy?: GetUserDataShort | null;
  /**
   * Berechnete Service-Einheiten dieser einzelnen Lizenz (basierend auf OptionValues × FileTypeLicenseOption.ServiceEinheiten)
   * @format decimal
   */
  serviceEinheiten?: number;
  /**
   * Persistierter Snapshot der Service-Einheiten (Stand bei Request/Approve, wird durch Reconcile aktualisiert)
   * @format decimal
   */
  serviceEinheitenSnapshot?: number;
  /**
   * Zeitpunkt der letzten Aktualisierung des Snapshots
   * @format date-time
   */
  serviceEinheitenSnapshotUpdatedAt?: string | null;
  /** Wenn true: Lizenz wird nicht in Vertrags-Gesamtsumme gezählt */
  excludeFromCalculation?: boolean;
  /** Grund des Ausschlusses (optional) */
  excludeFromCalculationReason?: string | null;
}

/** Status einer FileTypeLicense */
export enum FileTypeLicenseStatus {
  Draft = 0,
  Requested = 1,
  Approved = 2,
  Active = 3,
  Rejected = 4,
  Expired = 5,
}

/** Request-Modell für die Erstellung einer FileTypeLicense */
export interface CreateFileTypeLicenseRequest {
  /** Optional eigene Lizenz-ID */
  licenseId?: string | null;
  /** Optionaler Anzeigename der Lizenz */
  licenseName?: string | null;
  /**
   * FileType ID
   * @format guid
   */
  fileTypeId?: string;
  /**
   * Ablaufdatum der Lizenz (optional)
   * @format date-time
   */
  expiresAt?: string | null;
  /** Freitext/Notiz zur Lizenz */
  notes?: string | null;
  /**
   * Ersteller-UserId (optional)
   * @format guid
   */
  createdByUserId?: string | null;
  /** Optionen mit Werten */
  licenseOptions?: LicenseOptionValue[] | null;
}

/** Lizenz-Option mit Wert */
export interface LicenseOptionValue {
  /** Identifier der Option */
  identifier?: string;
  /** Wert der Option (typabhängig) */
  value?: any;
}

/** Response-Modell für die Lizenzsammlung eines Devices */
export interface DeviceLicenseCollectionResponse {
  /**
   * Device ID
   * @format guid
   */
  deviceId?: string;
  /** Device Name */
  deviceName?: string;
  /** Hardware-Id des Devices */
  deviceHardwareId?: string | null;
  /**
   * Live berechnete Service-Einheiten über alle Module (aktuelle Rezeptur × aktuelle Werte)
   * @format decimal
   */
  serviceEinheitenTotal?: number | null;
  /**
   * Persistierter Snapshot der Service-Einheiten auf dem Device (Aggregation aller aktiven, nicht ausgeschlossenen, nicht abgelaufenen Lizenz-Snapshots)
   * @format decimal
   */
  serviceEinheitenTotalSnapshot?: number;
  /**
   * Zeitpunkt der letzten Aktualisierung des Device-Snapshots
   * @format date-time
   */
  serviceEinheitenTotalUpdatedAt?: string | null;
  /** Module/Lizenzübersichten je FileType */
  modules?: DeviceModuleOverviewResponse[];
}

/** Modul-Übersicht pro FileType */
export interface DeviceModuleOverviewResponse {
  /**
   * FileType ID
   * @format guid
   */
  fileTypeId?: string;
  /** FileType Name */
  fileTypeName?: string;
  /** PackageId des Produkts (optional) */
  packageId?: string | null;
  /** Optionen für dieses Modul (Aggregationen + Einzelwerte) */
  options?: DeviceModuleOptionOverview[];
  /** Einzellizenzen (Teile) für dieses Modul */
  licenses?: DeviceLicensePartResponse[];
}

/** Option-Übersicht innerhalb eines Moduls */
export interface DeviceModuleOptionOverview {
  /** Technischer Identifier der Option */
  identifier?: string;
  /** Anzeigename der Option */
  commonName?: string;
  /** Datentyp der Option */
  type?: LicenseOptionType;
  /** Aggregations-Modus (None/Sum/Max) */
  aggregationMode?: LicenseOptionAggregationMode;
  /**
   * Service-Einheiten pro Option innerhalb des FileTypes
   * @format int32
   */
  serviceEinheiten?: number | null;
  /**
   * Gesammelte Service-Einheiten aus dem Wert
   * @format decimal
   */
  serviceEinheitenTotal?: number | null;
  /** Finaler Wert für Anzeige */
  value?: any;
}

/** Einzelne Teillizenz innerhalb der Sammlung */
export interface DeviceLicensePartResponse {
  /**
   * Lizenz-ID
   * @format guid
   */
  licenseId?: string;
  /** Status der Teillizenz */
  status?: FileTypeLicenseStatus;
  /**
   * Ausstellungsdatum
   * @format date-time
   */
  issuedAt?: string;
  /**
   * Ablaufdatum (optional)
   * @format date-time
   */
  expiresAt?: string | null;
  /** Notizen zur Teillizenz */
  notes?: string | null;
  /** Options der Teillizenz (Defaults + Overrides) */
  options?: Record<string, any>;
  /**
   * Persistierter Snapshot der Service-Einheiten dieser Teillizenz
   * @format decimal
   */
  serviceEinheitenSnapshot?: number;
  /** Wenn true: Lizenz ist aus der Vertrags-Gesamtsumme ausgenommen */
  excludeFromCalculation?: boolean;
}

/** Request-Modell für die Ablehnung einer Lizenzanfrage */
export interface RejectLicenseRequest {
  /** Grund der Ablehnung */
  rejectionReason?: string;
}

/**
 * Preview-Response für die Neuberechnung der Service-Einheiten einer einzelnen Lizenz.
 * Wird durch Reconcile-Endpoint erzeugt und durch Confirm-Endpoint mit Token persistiert.
 */
export interface LicenseReconciliationPreview {
  /**
   * Lizenz-ID
   * @format guid
   */
  licenseId?: string;
  /**
   * Aktuell gespeicherter Snapshot-Wert
   * @format decimal
   */
  current?: number;
  /**
   * Neu berechneter Wert auf Basis der aktuellen Rezeptur
   * @format decimal
   */
  recalculated?: number;
  /**
   * Differenz (Recalculated - Current)
   * @format decimal
   */
  delta?: number;
  /** Aufschlüsselung pro Option */
  options?: ReconciliationOptionDiff[];
  /** Token zur Bestätigung der Änderung (10 min gültig) */
  token?: string;
  /**
   * Ablaufzeitpunkt des Tokens
   * @format date-time
   */
  expiresAt?: string;
}

/** Diff für eine einzelne Option in der License-Reconcile-Preview. */
export interface ReconciliationOptionDiff {
  /** Technischer Identifier der Option */
  identifier?: string;
  /** Anzeigename der Option */
  commonName?: string;
  /**
   * Gespeicherter Snapshot-Wert der Option
   * @format decimal
   */
  current?: number;
  /**
   * Neu berechneter Wert
   * @format decimal
   */
  recalculated?: number;
  /**
   * Differenz (Recalculated - Current)
   * @format decimal
   */
  delta?: number;
}

/** Antwort nach erfolgreicher Bestätigung (Confirm) einer Reconcile-Preview für eine Lizenz. */
export interface LicenseReconciliationResult {
  /**
   * Lizenz-ID
   * @format guid
   */
  licenseId?: string;
  /**
   * Neuer, persistierter Snapshot der Lizenz
   * @format decimal
   */
  serviceEinheitenSnapshot?: number;
  /**
   * Zeitpunkt der Aktualisierung
   * @format date-time
   */
  updatedAt?: string;
}

/** Request-Body für Confirm-Endpoints. */
export interface ConfirmReconciliationRequest {
  /** Der Token aus der vorherigen Preview-Response */
  token?: string;
}

/** Request für den Exclude-Flag einer Lizenz. */
export interface SetLicenseExcludeRequest {
  /** True = Lizenz aus der Berechnung ausnehmen, False = wieder berücksichtigen */
  exclude?: boolean;
  /** Optionaler Grund */
  reason?: string | null;
}

/** Ergebnis des Admin-Endpoints zur kompletten Neuberechnung. */
export interface AdminRecalculateResult {
  /**
   * Anzahl aktualisierter Lizenzen
   * @format int32
   */
  licensesUpdated?: number;
  /**
   * Anzahl aktualisierter Verträge
   * @format int32
   */
  contractsUpdated?: number;
  /**
   * Zeitpunkt der Ausführung
   * @format date-time
   */
  completedAt?: string;
  /**
   * Dauer in Millisekunden
   * @format int64
   */
  durationMs?: number;
}

/** DTO for returning products */
export interface GetProductsData {
  /**
   * Id of Product
   * @format guid
   */
  id?: string;
  /** Public link to find Product */
  link?: string;
  /**
   * Individual name of Product
   * @example "Zentrale Bedieneinrichtung (ZBE)
   *             "
   */
  name?: string;
  /**
   * Description of Product
   * @example "Zentrale Bedieneinrichtung (ZBE) für die Feuerwehr
   *             "
   */
  description?: string;
}

/** Holds data related to a file. */
export interface FileDataResponse {
  /**
   * The unique identifier for the file, which is also used as the filename in storage.
   * @format guid
   * @example "3D290374-8689-4856-B5C4-35E0414F66E8"
   */
  id?: string;
  /**
   * The original name of the file before it was uploaded to the support system.
   * @example "AfVis-6.3.12(100)-Setup.exe"
   */
  fileName?: string;
  /** The version to which the file belongs. */
  version?: GetVersionDataCustomer | null;
  /** The product to which the file belongs. */
  product?: GetProductsData | null;
  /**
   * The file's extension.
   * @example ".exe"
   */
  extension?: string;
  /** The type of the file, used for filtering. */
  type?: GetFileTypeData;
  /**
   * The host system/platform for this file (Windows, Android, iOS, etc.)
   * @format guid
   */
  hostSystemId?: string | null;
  /** The host system/platform name. */
  hostSystemName?: string | null;
  /**
   * Indicates if the file is a debug version. Debug versions are only available for support purposes.
   * @example false
   */
  debugVersion?: boolean;
  /**
   * The file's MIME type, used for downloading the file from storage.
   * @example "application/pdf"
   */
  mimeType?: string;
}

export interface FileUploadHeader {
  /**
   * The major version number.
   * @format int32
   * @example 3
   */
  major?: number;
  /**
   * The minor version number.
   * @format int32
   * @example 1
   */
  minor?: number;
  /**
   * The patch version number.
   * @format int32
   * @example 0
   */
  patch?: number;
  /**
   * The unique identifier for the product.
   * @format guid
   * @example "3D290374-8689-4856-B5C4-35E0414F66E8"
   */
  productId?: string;
  /**
   * FileTypeId of FileType which belongs to this file
   * @format guid
   */
  fileTypeId?: string;
  /**
   * HostSystemId specifies which platform this file is for
   * @format guid
   */
  hostSystemId?: string | null;
  /** Filename of the file uploaded */
  fileName?: string;
  /** File which will be uploaded */
  contentType?: string;
}

/**
 * HTTP get type for generating password  data
 *
 */
export interface GetServiceData {
  /**
   * Support in given format.
   * Can be used to check if system has current support contract
   * ABC2-B7J1
   *
   */
  supportId?: string | null;
  /**
   * Generated password
   *
   */
  password?: string;
  /**
   * System software version
   *
   */
  softwareVersion?: string | null;
  /**
   * System timestamp
   *
   * @format int32
   */
  timestamp?: number | null;
  /**
   * System hardware version
   *
   */
  hardwareVersion?: string | null;
}

/**
 * Set of url parameters to find correct support contract and generate password
 *
 */
export interface ResolveServiceData {
  /**
   * Support ID
   *
   * @example "HQXBX-BU8PB"
   */
  si?: string | null;
  /**
   * Software Version
   *
   * @example "6.3.10"
   */
  sw?: string | null;
  /**
   * Hardware
   *
   * @example "-"
   */
  hw?: string | null;
  /**
   * Service Token
   *
   * @example "30cd-1907-26a4"
   */
  st?: string;
  /**
   * Remaining Time
   *
   * @format int32
   * @example 0
   */
  vf?: number | null;
  /**
   * Timestamp
   *
   * @format int32
   * @example 43200
   */
  ts?: number | null;
}

/**
 * FileType DTO for license selection in UI.
 *
 */
export interface FileTypeLicenseDto {
  /**
   * @format guid
   * @minLength 1
   */
  id: string;
  /** @minLength 1 */
  name: string;
}

/** Represents the response data for a license. */
export interface LicenseResponseDto {
  /** @format guid */
  id?: string;
  userName?: string;
  /** @format guid */
  userId?: string;
  description?: string;
  hostId?: string;
  supportContract?: string;
  supportCodeId?: string;
  /** @format guid */
  fileTypeId?: string;
  fileTypeName?: string | null;
  version?: number;
  tag?: string | null;
  tagName?: string | null;
  /** @format date-time */
  requestedAt?: string;
  /** @format date-time */
  licenseGeneratedAt?: string | null;
  licenseCode?: string | null;
  /** Optional callback URL to be called when the license is generated */
  callbackUrl?: string | null;
  /** Status of the license. */
  status?: LicenseStatus;
}

/** Represents the status of a license. */
export enum LicenseStatus {
  InCart = 0,
  Ordered = 1,
  LicenseGenerated = 2,
  Revoked = 3,
  Rejected = 4,
}

export interface RequestsLicenseDto {
  /**
   * Individual Description. Used for customers
   * @minLength 1
   */
  description: string;
  /**
   * Host ID for which the license is generated
   * @minLength 1
   */
  hostId: string;
  /**
   * Corresponding Support Contract
   * @minLength 1
   */
  supportCodeId: string;
  /**
   * If of the file type the license should be generated for
   * @format guid
   * @minLength 1
   */
  fileTypeId: string;
  /** Tag for which the generation is done */
  tag?: string | null;
  /** Optional callback URL to be called when the license is generated */
  callbackUrl?: string | null;
}

/**
 * Data transfer object for updating an existing license request.
 * Allows remapping a license to a different product/variant.
 */
export interface UpdateLicenseDto {
  /**
   * New file type ID (product) the license should be generated for
   * @format guid
   * @minLength 1
   */
  fileTypeId: string;
  /** New tag (variant) for which the generation is done */
  tag?: string | null;
  /** Optional: Update the description */
  description?: string | null;
}

/**
 * HTTP Return value for support code data
 *
 */
export interface GetQuickSupportData {
  /**
   * Support code id
   *
   */
  id?: string;
  /**
   * Support code id
   *
   */
  isValid?: boolean;
  /**
   * Name of the support code (can be used to describe the system)
   *
   */
  name?: string;
  /**
   * Contract number
   *
   */
  contractContractId?: string;
  /**
   * Contract title
   *
   */
  contractTitle?: string;
  contractExpire?: string;
  contractInfinite?: boolean;
}

/**
 * Bad request reponse objece
 *
 */
export interface NotFoundResponse {
  /**
   * HTML Status code
   *
   * @format int32
   * @example 404
   */
  statusCode?: number;
  /**
   * Self defined message (e.G. kein login möglich)
   *
   * @example "Der Nutzer wurde nicht gefunden"
   */
  message?: string;
}

/**
 * HTTP Post type for adding support code data
 *
 */
export interface AddSupportCodeData {
  /**
   * Support ID
   *
   */
  supportId?: string;
  /**
   * System name
   *
   */
  name?: string;
  /**
   * URL to Redirect to
   *
   */
  redirectUrl?: string;
}

/**
 * HTTP Return value for support contract data
 *
 */
export interface GetSupportContractData {
  id?: string;
  /**
   * Short title where Support Contract will belong to (e.G. ELW1 JUH BONN)
   *
   */
  title?: string;
  /**
   * Name of the customer where Support Contract belongs to (e.G. JUH BONN)
   *
   */
  customerName?: string;
  /**
   * Date and Time on which the Support Contract was created
   *
   * @format date-time
   */
  created?: string;
  /**
   * DateTime on which Support ID will expire.
   * Default expiration date: Now + 1 Year
   *
   * @format date
   */
  expire?: string;
  /**
   * Comment which can be added to support contract
   *
   */
  comment?: string;
  /**
   * Contract ID of Customer Relationship Management
   *
   */
  contractId?: string;
  /**
   * Customer ID of Customer Relationship Management
   *
   */
  customerId?: string;
  /**
   * Filter tags for the current support contract
   *
   */
  filterTags?: GetFilterTagData[];
  /**
   * Infinite contract
   *
   */
  infinite?: boolean;
  /**
   * Number of FilterTags for current contract
   * @format int32
   */
  filterTagsCount?: number;
  /** Get data of support contracts to display in UI */
  supportCodes?: GetQuickSupportData[];
  /**
   * Support contract status between 0 (expired) and 3 (long term)
   *
   *
   *         3At least 3 years
   *
   *
   *         2At least 60 days
   *
   *
   *         1Valid but less then 60 days
   *
   *
   *         0Expired
   *
   *
   *
   * @format int32
   */
  status?: number;
  /**
   * Persistierte Summe der Service-Einheiten über alle aktiven, nicht ausgeschlossenen
   * und nicht abgelaufenen Lizenzen der Devices dieses Support-Vertrags.
   * @format decimal
   */
  serviceEinheitenTotalSnapshot?: number;
  /**
   * Zeitpunkt der letzten Aktualisierung des Service-Einheiten-Snapshots.
   * @format date-time
   */
  serviceEinheitenTotalUpdatedAt?: string | null;
  /**
   * True, wenn der gespeicherte Snapshot gegenüber der aktuellen Rezeptur oder
   * Ausschluss-Konfiguration veraltet ist und eine Neuberechnung empfohlen wird.
   */
  serviceEinheitenSnapshotStale?: boolean;
}

/**
 * Summary statistics for support contracts.
 *
 */
export interface SupportContractSummaryDto {
  /**
   * Total number of accessible contracts.
   *
   * @format int32
   */
  totalContracts?: number;
  /**
   * Number of active contracts (including infinite).
   *
   * @format int32
   */
  activeContracts?: number;
  /**
   * Number of contracts expiring soon.
   *
   * @format int32
   */
  expiringSoonContracts?: number;
  /**
   * Number of expired contracts.
   *
   * @format int32
   */
  expiredContracts?: number;
  /**
   * Number of infinite contracts.
   *
   * @format int32
   */
  infiniteContracts?: number;
}

/**
 * HTTP Post to create new contact in contact system
 *
 */
export interface CreateContactData {
  /**
   * Support contact title
   *
   */
  title?: string;
  /**
   * Support contact content
   *
   */
  content?: string;
  /**
   * Support Contract ID where contact is belonging to
   *
   */
  contract?: string;
  /**
   * Support or new offer
   *
   */
  isSupport?: boolean;
  /**
   * Service ID of the corresponding system
   *
   */
  serviceId?: string;
  /**
   * Type of the contact. Default is 1 (Keine Angabe)
   * @format int32
   */
  contactType?: number;
}

/**
 * HTTP Post type for adding support contract data
 *
 */
export interface AddSupportContractData {
  /**
   * Short title where Support Contract will belong to (e.G. ELW1 JUH BONN)
   *
   */
  title?: string;
  /**
   * Name of the customer where Support Contract belongs to (e.G. JUH BONN)
   *
   */
  customerName?: string;
  /**
   * Date and Time on which the Support Contract was created
   *
   * @format date
   */
  expire?: string | null;
  /**
   * Comment which can be added to support contract
   *
   */
  comment?: string;
}

/**
 * HTTP GET return type for user
 *
 */
export interface GetUserData {
  /**
   * UUID of the user
   *
   * @format guid
   * @example "cda9cb75-6479-4d05-9560-343935a0800d"
   */
  id?: string;
  /**
   * E-Mail Address of the user
   *
   * @example "max.mustermann@musterstadt.de"
   */
  eMail?: string;
  /**
   * Full name of the user
   *
   * @example "Max Mustermann"
   */
  name?: string;
  /**
   * Saltuation including name of the user
   *
   * @example "Sehr geehrter Herr Max Mustermann,"
   */
  anrede?: string;
  /**
   * Usergroup with specified access rights
   *
   */
  userGroup?: EUserGroup;
  /**
   * Date Time when user was created
   *
   * @format date-time
   * @example "2023-05-17T10:57:30.129177"
   */
  created?: string;
  /**
   * Date time of the last login (e.G. see which users downloaded a file)
   *
   * @format date-time
   * @example "2023-05-17T10:57:30.129177"
   */
  lastLogin?: string | null;
  /**
   * DateTime when Welcome Mail was sent
   *
   * @format date-time
   * @example "2023-05-17T10:57:30.129177"
   */
  sentWelcomeMail?: string | null;
  /**
   * Shows is user is currently locked
   *
   * @example true
   */
  locked?: boolean;
  /**
   * Minimum version stage current user can see
   *
   * @example 3
   */
  minAllowedStage?: EVersionStage;
  /** @format guid */
  acceptedTermsId?: string | null;
}

/**
 * User Group Enum
 *
 */
export enum EUserGroup {
  SUPER_ADMIN = 0,
  ADMIN = 1,
  DEVELOPMENT = 2,
  OFFICE = 3,
  CUSTOMER = 4,
}

/** Zusammengefasste Service-Einheiten-Info eines Support-Vertrags für performante Listen-Anzeige. */
export interface SupportContractServiceUnitsResponse {
  /**
   * Vertrags-ID
   * @format guid
   */
  contractId?: string;
  /** Externe Vertragsnummer */
  contractExternalId?: string;
  /** Vertragstitel */
  title?: string;
  /** Kundenname */
  customerName?: string;
  /**
   * Persistierte Gesamtsumme der Service-Einheiten
   * @format decimal
   */
  serviceEinheitenTotalSnapshot?: number;
  /**
   * Zeitpunkt der letzten Aktualisierung
   * @format date-time
   */
  serviceEinheitenTotalUpdatedAt?: string | null;
  /** True wenn Snapshot gegenüber aktueller Rezeptur veraltet ist */
  serviceEinheitenSnapshotStale?: boolean;
}

/** Preview-Response für die Neuberechnung der Service-Einheiten eines Support-Vertrags. */
export interface ContractReconciliationPreview {
  /**
   * Support-Vertrag ID
   * @format guid
   */
  contractId?: string;
  /**
   * Aktuell gespeicherter Gesamt-Snapshot des Vertrags
   * @format decimal
   */
  current?: number;
  /**
   * Neu berechneter Gesamtwert
   * @format decimal
   */
  recalculated?: number;
  /**
   * Differenz (Recalculated - Current)
   * @format decimal
   */
  delta?: number;
  /** Aufschlüsselung je Lizenz */
  licenses?: ReconciliationLicenseDiff[];
  /** Token zur Bestätigung der Änderung (10 min gültig) */
  token?: string;
  /**
   * Ablaufzeitpunkt des Tokens
   * @format date-time
   */
  expiresAt?: string;
}

/** Diff für eine einzelne Lizenz in der Contract-Reconcile-Preview. */
export interface ReconciliationLicenseDiff {
  /**
   * Lizenz-ID
   * @format guid
   */
  licenseId?: string;
  /**
   * Device-ID
   * @format guid
   */
  deviceId?: string;
  /** Device-Name */
  deviceName?: string;
  /** FileType-Name */
  fileTypeName?: string;
  /**
   * Gespeicherter Snapshot-Wert der Lizenz
   * @format decimal
   */
  current?: number;
  /**
   * Neu berechneter Wert dieser Lizenz. 0 wenn die Lizenz abgelaufen,
   * ausgeschlossen oder nicht aktiv ist — daraus ergibt sich dann ein negatives Delta.
   * @format decimal
   */
  recalculated?: number;
  /**
   * Differenz (Recalculated - Current)
   * @format decimal
   */
  delta?: number;
  /** True wenn die Lizenz aus der Berechnung ausgenommen ist */
  excluded?: boolean;
  /** True wenn die Lizenz abgelaufen ist */
  expired?: boolean;
  /** Status der Lizenz */
  status?: FileTypeLicenseStatus;
}

/** Antwort nach erfolgreicher Bestätigung (Confirm) einer Reconcile-Preview für einen Vertrag. */
export interface ContractReconciliationResult {
  /**
   * Vertrags-ID
   * @format guid
   */
  contractId?: string;
  /**
   * Neue, persistierte Gesamtsumme
   * @format decimal
   */
  serviceEinheitenTotalSnapshot?: number;
  /**
   * Zeitpunkt der Aktualisierung
   * @format date-time
   */
  updatedAt?: string;
  /**
   * Anzahl der mit aktualisierten Lizenzen
   * @format int32
   */
  licensesUpdated?: number;
}

/** Represents a data transfer object for fetching builds. */
export interface GetBuildsDto {
  /** Gets or sets the Id of the property. */
  id?: string;
  /** Gets or sets the name. */
  name?: string;
  /** Gets or sets the branch. */
  branch?: string;
  /** Gets or sets the URL property. */
  url?: string;
  /** Gets or sets the build type. */
  buildType?: string;
  /** Gets or sets the build type name. */
  buildTypeName?: string;
}

/** Represents a DTO (Data Transfer Object) for file download information. */
export interface FileDownloadDto {
  /** Represents the version key of a product. */
  versionKey?: VersionKey;
  /** Gets or sets the build ID of the BuildServer matching the version. */
  buildId?: string;
}

/**
 * HTTP Return value for usage terms data
 *
 */
export interface GetTermsData {
  /**
   * Internal ID of the Terms (for technical purpose)
   *
   * @format guid
   */
  id?: string;
  /**
   * Public Version titpe
   *
   */
  versionTitle?: string;
  /**
   * Content of the Terms. Will be stored in Markdown text
   *
   */
  content?: string;
  /**
   * Date time when Terms where created.
   * Latest date is always the one which is checked by system.
   *
   * @format date-time
   */
  created?: string;
}

/**
 * HTTP POST value for usage terms data
 *
 */
export interface AddTermsData {
  /**
   * Title of the Term to be added (also used to version terms)
   *
   */
  versionTitle?: string;
  /**
   * Content of the Terms. Will be stored in Markdown text
   *
   */
  content?: string;
}

/** Represents user registration data. */
export interface RegisterUserData {
  /**
   * Gets or sets the customer name.
   * @minLength 1
   * @example "John Doe"
   */
  customer: string;
  /**
   * Gets or sets the email address.
   * @format email
   * @minLength 1
   * @example "john.doe@example.com"
   */
  email: string;
  /**
   * Gets or sets the gender of the user.
   * @minLength 1
   */
  sex: string;
  /**
   * Gets or sets the first name of the user.
   * @minLength 1
   * @example "John"
   */
  firstName: string;
  /**
   * Gets or sets the last name of the user.
   * @minLength 1
   * @example "Doe"
   */
  lastName: string;
  /**
   * Gets or sets the support contract ID (if applicable).
   * @example "12345-12345"
   */
  supportContractId?: string | null;
  /**
   * Gets or sets additional information provided by the user.
   * @example "Some additional information"
   */
  furtherInformation?: string | null;
  /**
   * Gets or sets a value indicating whether the user allows receiving extra emails.
   * @example true
   */
  allowExtraMail: boolean;
  /**
   * Gets or sets a value indicating whether the user allows saving data.
   * @example true
   */
  allowSaveData: boolean;
  /**
   * Gets or sets the ReCaptcha token for validation.
   * @minLength 1
   */
  reCaptchaToken: string;
}

/**
 * Return data for sign in process
 *
 */
export interface SignInUserData {
  /**
   * Current user id
   * @format guid
   */
  id?: string;
  /**
   * User E-Mail
   *
   */
  eMail?: string;
  /**
   * Username
   *
   */
  name?: string;
  /**
   * User Group
   *
   */
  userGroup?: EUserGroup;
  /**
   * Need change password after login
   *
   */
  needChangePassword?: boolean;
  /**
   * Authentication token
   *
   */
  token?: string;
}

/**
 * HTTP POST type to add new user
 *
 */
export interface AddUserData {
  /**
   * E-Mail (used for login)
   *
   */
  eMail?: string;
  /**
   * Full name of the user
   *
   */
  name?: string;
  /**
   * Salutation including the name
   *
   */
  anrede?: string;
  /**
   * User group with access rights
   *
   */
  userGroup?: EUserGroup;
  /**
   * Minimum version stage current user can see
   *
   */
  minAllowedStage?: EVersionStage;
  /**
   * First password (temp password)
   *
   */
  password?: string;
  /**
   * Repeated first password (temp password) to ensure password is correct
   *
   */
  passwordRepeat?: string;
}

/**
 * HTTP POST type to edit existing user
 *
 */
export interface EditUserData {
  /**
   * New full name of the user
   *
   */
  name?: string | null;
  /**
   * New salutation including name
   *
   */
  anrede?: string | null;
  /**
   * New UserGroup
   *
   */
  userGroup?: EUserGroup | null;
  /**
   * Minimum version stage current user can see
   *
   */
  minAllowedStage?: EVersionStage | null;
  /**
   * optional new password
   *
   */
  password?: string | null;
  /**
   * optional new password repeat
   *
   */
  passwordRepeat?: string | null;
}

/**
 * HTTP POST to change own user
 *
 */
export interface ChangePasswordData {
  /**
   * Current used password (can be temp password or current password)
   *
   */
  currentPassword?: string;
  /**
   * New user password
   *
   */
  newPassword?: string;
  /**
   * New repeated password
   *
   */
  newPasswordRepeat?: string;
}

export interface GetSupportUserData {
  /**
   * UUID of the user
   *
   * @format guid
   * @example "cda9cb75-6479-4d05-9560-343935a0800d"
   */
  id?: string;
  /**
   * E-Mail Address of the user
   *
   * @example "max.mustermann@musterstadt.de"
   */
  eMail?: string;
  /**
   * Full name of the user
   *
   * @example "Max Mustermann"
   */
  name?: string;
  /**
   * Saltuation including name of the user
   *
   * @example "Sehr geehrter Herr Max Mustermann,"
   */
  anrede?: string;
  /**
   * Usergroup with specified access rights
   *
   */
  userGroup?: EUserGroup;
  /**
   * Date Time when user was created
   *
   * @format date-time
   * @example "2023-05-17T10:57:30.129177"
   */
  created?: string;
  /**
   * Date time of the last login (e.G. see which users downloaded a file)
   *
   * @format date-time
   * @example "2023-05-17T10:57:30.129177"
   */
  lastLogin?: string | null;
  /**
   * Shows is user is currently locked
   *
   * @example true
   */
  locked?: boolean;
  /**
   * Minimum version stage current user can see
   *
   * @example 3
   */
  minAllowedStage?: EVersionStage;
  /** List all support contracts of the user */
  supportContracts?: GetSupportContractData[];
  /** List all filter tags of the user */
  filterTags?: GetFilterTagData[];
  /** Get terms user accepted */
  acceptedTerms?: GetTermsData | null;
}

/**
 * HTTP POST Data to add new version
 *
 */
export interface AddVersionData {
  /** VersionKey to find specific version */
  versionKey?: VersionKey;
  /**
   * Set version stage for the current version
   *
   * @example "EVersionStage.RELEASE_CANDIDATE"
   */
  stage?: EVersionStage;
  /**
   * Short version description (name of the version)
   *
   */
  description?: string;
  /**
   * Summary of all changes as VersionChanges object.
   * Can be used for public displaying of the version
   *
   */
  changes?: VersionChanges;
  /**
   * Description for critical updates. If empty current version is NOT a critical version.
   *
   */
  criticalUpdate?: string | null;
  /**
   * Internal information (only for office, development, ...)
   *
   */
  internalInformation?: string;
  /**
   * Date when version was / will be approved
   * @format date
   */
  approved?: string | null;
  /** Header of version */
  header?: string | null;
  /** Footer of version */
  footer?: string | null;
}

/** Data required to check file download permissions before actual download. */
export interface GetFileCheckDownload {
  /**
   * Determines if the file can be downloaded.
   * @example false
   */
  canDownload?: boolean;
  /**
   * Message to be communicated to the user regarding the download.
   * @example "You have exceeded your download limit."
   */
  message?: string;
  /**
   * The maximum allowed major version for download.
   * @format int32
   * @example 1
   */
  maxMajorVersion?: number;
  /**
   * The maximum allowed minor version for download.
   * @format int32
   * @example 0
   */
  maxMinorVersion?: number;
  /**
   * The maximum allowed patch version for download.
   * @format int32
   * @example 0
   */
  maxPatchVersion?: number;
}

/** Represents a YouTrack issue with basic information. */
export interface YouTrackIssueDTO {
  /** Gets or sets the issue ID as displayed in YouTrack (e.g., "SP-123"). */
  idReadable?: string;
  /** Gets or sets the issue summary/title. */
  summary?: string;
  /** Gets or sets the current status of the issue. */
  status?: string | null;
  /** Gets or sets the Support ID associated with this ticket. */
  supportId?: string | null;
  /** Gets or sets the current version (Aktuelle Version) of the software. */
  currentVersion?: string | null;
  /** Gets or sets the maintenance contract number (Wartungsvertrag Nummer). */
  maintenanceContractNumber?: string | null;
  /**
   * Gets or sets the creation timestamp (Unix timestamp in milliseconds).
   * @format int64
   */
  created?: number | null;
  /**
   * Gets or sets the last update timestamp (Unix timestamp in milliseconds).
   * @format int64
   */
  updated?: number | null;
}

/**
 * Statistics summary for YouTrack tickets.
 *
 */
export interface YouTrackStatisticsDto {
  /**
   * Total number of tickets in the query set.
   *
   * @format int32
   */
  totalTickets?: number;
  /**
   * Number of open tickets.
   *
   * @format int32
   */
  openTickets?: number;
  /**
   * Number of closed tickets.
   *
   * @format int32
   */
  closedTickets?: number;
  /**
   * Total number of open Helpdesk tickets (only available for DEVELOPMENT users).
   *
   * @format int32
   */
  totalOpenHelpdeskTickets?: number | null;
  /**
   * Average response time in hours (based on public agent comments).
   *
   * @format double
   */
  averageResponseTimeHours?: number | null;
  /**
   * Number of tickets used for response time calculation.
   *
   * @format int32
   */
  responseTimeSampleSize?: number;
  /**
   * Grouped tickets by status.
   *
   */
  ticketsByStatus?: YouTrackStatusCountDto[];
  /**
   * List of open tickets.
   *
   */
  openTicketsList?: YouTrackIssueDTO[];
}

/**
 * Status grouping for tickets.
 *
 */
export interface YouTrackStatusCountDto {
  /**
   * Status name.
   *
   */
  status?: string;
  /**
   * Count for the status.
   *
   * @format int32
   */
  count?: number;
}

/** Represents detailed information about a YouTrack issue including description and comments. */
export type YouTrackIssueDetailDTO = YouTrackIssueDTO & {
  /** Gets or sets the issue description. */
  description?: string | null;
  /** Gets or sets the reporter/creator of the issue. */
  reporter?: YouTrackAuthorDTO | null;
  /** Gets or sets the list of public comments on the issue. */
  comments?: YouTrackCommentDTO[];
};

export interface YouTrackAuthorDTO {
  login?: string;
  displayName?: string;
}

export interface YouTrackCommentDTO {
  text?: string;
  author?: YouTrackAuthorDTO;
  /** @format int64 */
  created?: number;
  isDeleted?: boolean;
  /** Indicates the type of author: Mine (0), Other (1), or Agent (2). */
  authorType?: CommentAuthorType;
}

/** Defines the type of comment author. */
export enum CommentAuthorType {
  Mine = 0,
  Other = 1,
  Agent = 2,
}

/**
 * Request model for creating a new comment on a YouTrack issue.
 * The comment will be created on behalf of the currently authenticated user.
 */
export interface CreateCommentRequest {
  /** The text content of the comment. */
  text?: string;
  /**
   * Whether the comment should be publicly visible.
   * If true, everyone can see the comment. If false, only project team members can see it.
   */
  isPublic?: boolean;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "http://localhost:5297" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Support Server
 * @version 99.99.99.9
 * @baseUrl http://localhost:5297
 *
 * Reichert Support Server
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  alive = {
    /**
     * No description
     *
     * @tags Alive
     * @name AliveGet
     * @summary Health check endpoint that returns the current date and server version.
     * @request GET:/Alive
     * @secure
     */
    aliveGet: (params: RequestParams = {}) =>
      this.request<AliveResponse, any>({
        path: `/Alive`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  appStore = {
    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreGetFileTypes
     * @summary Get list of all file types with latest file per host system.
     * @request GET:/AppStore/Apps
     * @secure
     */
    appStoreGetFileTypes: (
      query?: {
        /**
         * DEPRECATED: Filter by FileTypeClass (use documentationFilter instead)
         * @default "UNDEFINED"
         */
        variant?: FileTypeClass;
        /** Filter by specific HostSystem IDs */
        system?: string[] | null;
        /**
         * Filter for documentation HostSystems. Default: All
         * @default "All"
         */
        documentationFilter?: DocumentationFilter;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetFileTypeLatestHostSystemFileData[], any>({
        path: `/AppStore/Apps`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreGetFileTypesPublic
     * @summary Get list of public file types.
     * @request GET:/AppStore/Apps/Public
     * @secure
     */
    appStoreGetFileTypesPublic: (
      query?: {
        /**
         * DEPRECATED: Filter by FileTypeClass (use documentationFilter instead)
         * @default "UNDEFINED"
         */
        variant?: FileTypeClass;
        /**
         * Filter for documentation HostSystems. Default: All
         * @default "All"
         */
        documentationFilter?: DocumentationFilter;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetFileTypeData[], any>({
        path: `/AppStore/Apps/Public`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreGetFileType
     * @summary Get file type details.
     * @request GET:/AppStore/Apps/{id}
     * @secure
     */
    appStoreGetFileType: (id: string, params: RequestParams = {}) =>
      this.request<GetFileTypeData, any>({
        path: `/AppStore/Apps/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreGetFileTypePublic
     * @summary Get public file type details.
     * @request GET:/AppStore/Apps/Public/{id}
     * @secure
     */
    appStoreGetFileTypePublic: (id: string, params: RequestParams = {}) =>
      this.request<GetFileTypeData, any>({
        path: `/AppStore/Apps/Public/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreGetFileTypeVersions
     * @summary Get versions that contain files for a file type.
     * @request GET:/AppStore/Apps/{fileTypeId}/Versions
     * @secure
     */
    appStoreGetFileTypeVersions: (
      fileTypeId: string,
      query?: {
        /**
         * Filter for documentation HostSystems. Default: All
         * @default "All"
         */
        documentationFilter?: DocumentationFilter;
        /**
         * Maximum number of versions to return. Default: 3
         * @format int32
         * @default 3
         */
        maxVersions?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetVersionFileData[], any>({
        path: `/AppStore/Apps/${fileTypeId}/Versions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreGetFile
     * @summary Download a file by id.
     * @request GET:/AppStore/Downloads/{id}
     * @secure
     */
    appStoreGetFile: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/AppStore/Downloads/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreGetScreenshots
     * @summary Get screenshots for a file type.
     * @request GET:/AppStore/Apps/{fileTypeId}/Screenshots
     * @secure
     */
    appStoreGetScreenshots: (fileTypeId: string, params: RequestParams = {}) =>
      this.request<ImageDto[], any>({
        path: `/AppStore/Apps/${fileTypeId}/Screenshots`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreGetLogo
     * @summary Get logo for a file type.
     * @request GET:/AppStore/Apps/{fileTypeId}/Logo
     * @secure
     */
    appStoreGetLogo: (fileTypeId: string, params: RequestParams = {}) =>
      this.request<ImageDto, any>({
        path: `/AppStore/Apps/${fileTypeId}/Logo`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreGetImageDataRaw
     * @summary Get image data by id.
     * @request GET:/AppStore/Images/{imageId}
     * @secure
     */
    appStoreGetImageDataRaw: (imageId: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/AppStore/Images/${imageId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreRegisterDevice
     * @summary Register a device for the AppStore.
     * @request POST:/AppStore/Devices/Register
     * @secure
     */
    appStoreRegisterDevice: (data: RegisterDeviceModel, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/AppStore/Devices/Register`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreGetAppStoreFileTypeId
     * @summary Get the FileType ID for the AppStore APK.
     * @request GET:/AppStore/FileTypeId
     * @secure
     */
    appStoreGetAppStoreFileTypeId: (params: RequestParams = {}) =>
      this.request<AppStoreConfigDto, AppStoreConfigDto>({
        path: `/AppStore/FileTypeId`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreSetAppStoreFileTypeId
     * @summary Set the FileType ID for the AppStore APK (Admin only).
     * @request POST:/AppStore/FileTypeId
     * @secure
     */
    appStoreSetAppStoreFileTypeId: (data: string, params: RequestParams = {}) =>
      this.request<AppStoreConfigDto, any>({
        path: `/AppStore/FileTypeId`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags AppStore
 * @name AppStoreGetAppStoreInfo
 * @summary Get AppStore APK information (Anonymous access).
Returns version info if available.
 * @request GET:/AppStore/Info
 * @secure
 */
    appStoreGetAppStoreInfo: (params: RequestParams = {}) =>
      this.request<AppStoreInfoDto, AppStoreInfoDto>({
        path: `/AppStore/Info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreDownloadAppStore
     * @summary Download the latest AppStore APK (Anonymous access).
     * @request GET:/AppStore/Download
     * @secure
     */
    appStoreDownloadAppStore: (params: RequestParams = {}) =>
      this.request<File, string>({
        path: `/AppStore/Download`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  auditLog = {
    /**
     * No description
     *
     * @tags AuditLog
     * @name AuditLogGetAuditEntries
     * @summary Returns audit entries, optionally filtered by reference type and reference id.
     * @request GET:/AuditLog
     * @secure
     */
    auditLogGetAuditEntries: (
      query?: {
        /** Optional logical reference type (for example Device or License). */
        referenceType?: string | null;
        /** Optional reference id to match. */
        referenceId?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuditLogEntry[], any>({
        path: `/AuditLog`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  dashboard = {
    /**
     * No description
     *
     * @tags Dashboard
     * @name DashboardGetStatistics
     * @summary Retrieves dashboard statistics and recent versions.
     * @request GET:/Dashboard/statistics
     * @secure
     */
    dashboardGetStatistics: (
      query?: {
        /**
         * Number of days used for recent versions.
         * @format int32
         * @default 30
         */
        days?: number;
        /**
         * Maximum number of recent versions returned.
         * @format int32
         * @default 5
         */
        limit?: number;
        /**
         * Window in days for expiring contracts.
         * @format int32
         * @default 30
         */
        expiringSoonDays?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<DashboardStatisticsDto, any>({
        path: `/Dashboard/statistics`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  device = {
    /**
     * No description
     *
     * @tags Device
     * @name DeviceRegisterDevice
     * @request POST:/Device/Register
     * @secure
     */
    deviceRegisterDevice: (data: RegisterDeviceModel, params: RequestParams = {}) =>
      this.request<DeviceQueryModel, any>({
        path: `/Device/Register`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceSetDeviceStatus
     * @request POST:/Device/SetDeviceStatus
     * @secure
     */
    deviceSetDeviceStatus: (data: SetDeviceStatusModel, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Device/SetDeviceStatus`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceCreateDevice
     * @request POST:/Device
     * @secure
     */
    deviceCreateDevice: (data: CreateDeviceModel, params: RequestParams = {}) =>
      this.request<DeviceQueryModel, any>({
        path: `/Device`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceGetDevices
     * @request GET:/Device
     * @secure
     */
    deviceGetDevices: (
      query?: {
        supportCodeId?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeviceQueryModel[], any>({
        path: `/Device`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceGetDeletedDevices
     * @request GET:/Device/deleted
     * @secure
     */
    deviceGetDeletedDevices: (
      query?: {
        supportCodeId?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeviceQueryModel[], any>({
        path: `/Device/deleted`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceGetDevice
     * @request GET:/Device/{deviceId}
     * @secure
     */
    deviceGetDevice: (deviceId: string, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Device/${deviceId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceDeleteDevice
     * @summary Löscht ein Device endgültig aus der Datenbank. Nur möglich wenn Status = Deleted.
     * @request DELETE:/Device/{deviceId}
     * @secure
     */
    deviceDeleteDevice: (deviceId: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/Device/${deviceId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceUnlockRegistration
     * @request POST:/Device/{deviceId}/UnlockRegistration
     * @secure
     */
    deviceUnlockRegistration: (deviceId: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Device/${deviceId}/UnlockRegistration`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceAssignSupportCode
     * @request POST:/Device/{deviceId}/AssignSupportCode
     * @secure
     */
    deviceAssignSupportCode: (deviceId: string, data: AssignSupportCodeModel, params: RequestParams = {}) =>
      this.request<DeviceQueryModel, any>({
        path: `/Device/${deviceId}/AssignSupportCode`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceUpdateDeviceHostSystem
     * @request POST:/Device/{deviceId}/UpdateHostSystem
     * @secure
     */
    deviceUpdateDeviceHostSystem: (deviceId: string, data: UpdateDeviceHostSystemModel, params: RequestParams = {}) =>
      this.request<DeviceQueryModel, any>({
        path: `/Device/${deviceId}/UpdateHostSystem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceAssignHostId
     * @summary Weist einem bestellten Pending-Gerät einmalig eine Hardware-ID (HostID) zu.
     * @request POST:/Device/{deviceId}/AssignHostId
     * @secure
     */
    deviceAssignHostId: (deviceId: string, data: AssignHostIdModel, params: RequestParams = {}) =>
      this.request<DeviceQueryModel, any>({
        path: `/Device/${deviceId}/AssignHostId`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceReleaseHostId
     * @summary Löst die Host-ID-Bindung eines Devices (DEV only) und setzt das Device auf Pending.
     * @request POST:/Device/{deviceId}/ReleaseHostId
     * @secure
     */
    deviceReleaseHostId: (deviceId: string, data: ReleaseHostIdModel, params: RequestParams = {}) =>
      this.request<DeviceQueryModel, any>({
        path: `/Device/${deviceId}/ReleaseHostId`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceUploadLicenseXml
     * @request POST:/Device/{deviceId}/UploadLicenseXml
     * @secure
     */
    deviceUploadLicenseXml: (
      deviceId: string,
      data: {
        ContentType?: string | null;
        ContentDisposition?: string | null;
        Headers?: any[] | null;
        /** @format int64 */
        Length?: number;
        Name?: string | null;
        FileName?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<UploadLicenseXmlResponse, any>({
        path: `/Device/${deviceId}/UploadLicenseXml`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceUploadLicenseXmlByHostId
     * @summary Lädt eine IOE XML für ein Device hoch - identifiziert über die HostId aus der XML
     * @request POST:/Device/UploadLicenseXmlByHostId
     * @secure
     */
    deviceUploadLicenseXmlByHostId: (
      data: {
        ContentType?: string | null;
        ContentDisposition?: string | null;
        Headers?: any[] | null;
        /** @format int64 */
        Length?: number;
        Name?: string | null;
        FileName?: string | null;
      },
      query?: {
        /** Optionale SupportCode ID - wenn angegeben wird automatisch ein neues Gerät angelegt falls keins gefunden wird */
        supportCodeId?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<UploadLicenseXmlResponse, any>({
        path: `/Device/UploadLicenseXmlByHostId`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceHasIoeServerConfigXml
     * @summary Prüft, ob für ein Device eine IOE Server Config XML vorhanden ist
     * @request GET:/Device/{deviceId}/HasIoeServerConfigXml
     * @secure
     */
    deviceHasIoeServerConfigXml: (deviceId: string, params: RequestParams = {}) =>
      this.request<boolean, ProblemDetails>({
        path: `/Device/${deviceId}/HasIoeServerConfigXml`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceDownloadIoeServerConfigXml
     * @summary Lädt die IOE Server Config XML für ein Device herunter
     * @request GET:/Device/{deviceId}/DownloadIoeServerConfigXml
     * @secure
     */
    deviceDownloadIoeServerConfigXml: (deviceId: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/Device/${deviceId}/DownloadIoeServerConfigXml`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceCloneDevice
     * @summary Klont ein Device mit allen Lizenzen auf eine neue Host-ID. Nur für Admins.
     * @request POST:/Device/{deviceId}/clone
     * @secure
     */
    deviceCloneDevice: (deviceId: string, data: CloneDeviceModel, params: RequestParams = {}) =>
      this.request<DeviceQueryModel, ProblemDetails>({
        path: `/Device/${deviceId}/clone`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  api = {
    /**
     * No description
     *
     * @tags FileSharing
     * @name FileSharingUploadFile
     * @summary Uploads a file for a specific support contract
     * @request POST:/api/FileSharing/upload
     * @secure
     */
    fileSharingUploadFile: (
      data: {
        /** @format binary */
        File?: File | null;
        CustomTitle?: string | null;
        /** @format guid */
        SupportContractId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SharedFileDto, any>({
        path: `/api/FileSharing/upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileSharing
     * @name FileSharingDownloadFile
     * @summary Downloads a file by its ID
     * @request GET:/api/FileSharing/download/{fileId}
     * @secure
     */
    fileSharingDownloadFile: (fileId: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/api/FileSharing/download/${fileId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileSharing
     * @name FileSharingListFiles
     * @summary Lists all files available for a specific support contract
     * @request GET:/api/FileSharing/{supportId}
     * @secure
     */
    fileSharingListFiles: (supportId: string, params: RequestParams = {}) =>
      this.request<SharedFileDto[], any>({
        path: `/api/FileSharing/${supportId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags FileSharing
 * @name FileSharingUploadConfigFile
 * @summary Uploads a configuration file (XML/JSON only)
Only accessible by users with ACCESS_RIGHT permissions
Maximum file size: 1MB
 * @request POST:/api/FileSharing/config
 * @secure
 */
    fileSharingUploadConfigFile: (
      data: {
        /** @format binary */
        File?: File | null;
        CustomTitle?: string | null;
        /** @format guid */
        SupportContractId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SharedFileDto, any>({
        path: `/api/FileSharing/config`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags FileSharing
 * @name FileSharingUpdateFile
 * @summary Updates the content of an existing file
Only updates the file content and modified timestamp
 * @request PUT:/api/FileSharing/{fileId}
 * @secure
 */
    fileSharingUpdateFile: (
      fileId: string,
      data: {
        /** @format binary */
        file?: File | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<SharedFileDto, any>({
        path: `/api/FileSharing/${fileId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags FileSharing
 * @name FileSharingDeleteFile
 * @summary Deletes a file by its ID
OFFICE users can delete any file, other users can only delete their own files
 * @request DELETE:/api/FileSharing/{fileId}
 * @secure
 */
    fileSharingDeleteFile: (fileId: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/api/FileSharing/${fileId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileSharing
     * @name FileSharingListAllFiles
     * @summary Lists all files in the system (OFFICE only)
     * @request GET:/api/FileSharing/all
     * @secure
     */
    fileSharingListAllFiles: (params: RequestParams = {}) =>
      this.request<SharedFileDto[], any>({
        path: `/api/FileSharing/all`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags HostId
     * @name HostIdCheckHostId
     * @summary Analysiert eine Host-ID und gibt deren Metadaten zurück
     * @request GET:/api/HostId/check/{hostId}
     * @secure
     */
    hostIdCheckHostId: (hostId: string, params: RequestParams = {}) =>
      this.request<HostIdResponse, ProblemDetails | void>({
        path: `/api/HostId/check/${hostId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags HostId
     * @name HostIdGetVersion
     * @summary Gibt die Version der nativen Bibliothek zurück
     * @request GET:/api/HostId/version
     * @secure
     */
    hostIdGetVersion: (params: RequestParams = {}) =>
      this.request<HostIdVersionResponse, any>({
        path: `/api/HostId/version`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGenerateLicense
     * @summary Erstellt eine neue Lizenzdatei
     * @request POST:/api/License/generate
     * @secure
     */
    licenseGenerateLicense: (data: LicenseData, params: RequestParams = {}) =>
      this.request<LicenseFileResponse, any>({
        path: `/api/License/generate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseValidateLicense
     * @summary Validiert eine Lizenzdatei und gibt die Inhalte auch bei ungültiger Signatur zurück
     * @request POST:/api/License/validate
     * @secure
     */
    licenseValidateLicense: (data: ValidateLicenseRequest, params: RequestParams = {}) =>
      this.request<LicenseInspectionResponse, ProblemDetails>({
        path: `/api/License/validate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGenerateLicenseFile
     * @summary Generiert eine Lizenzdatei und gibt sie als Download zurück
     * @request POST:/api/License/generate/download
     * @secure
     */
    licenseGenerateLicenseFile: (data: LicenseData, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/api/License/generate/download`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetLicenseOptions
     * @summary Gibt alle verfügbaren Lizenz-Optionen zurück
     * @request GET:/api/License/options
     * @secure
     */
    licenseGetLicenseOptions: (
      query?: {
        /**
         * Nur aktive Optionen zurückgeben
         * @default true
         */
        activeOnly?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<LicenseOptionDto[], any>({
        path: `/api/License/options`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseCreateLicenseOption
     * @summary Erstellt eine neue Lizenz-Option
     * @request POST:/api/License/options
     * @secure
     */
    licenseCreateLicenseOption: (data: CreateLicenseOptionRequest, params: RequestParams = {}) =>
      this.request<LicenseOptionDto, any>({
        path: `/api/License/options`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetLicenseOption
     * @summary Gibt eine spezifische Lizenz-Option zurück
     * @request GET:/api/License/options/{id}
     * @secure
     */
    licenseGetLicenseOption: (id: string, params: RequestParams = {}) =>
      this.request<LicenseOptionDto, ProblemDetails>({
        path: `/api/License/options/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseUpdateLicenseOption
     * @summary Aktualisiert eine Lizenz-Option
     * @request PUT:/api/License/options/{id}
     * @secure
     */
    licenseUpdateLicenseOption: (id: string, data: CreateLicenseOptionRequest, params: RequestParams = {}) =>
      this.request<LicenseOptionDto, ProblemDetails>({
        path: `/api/License/options/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseDeleteLicenseOption
     * @summary Löscht eine Lizenz-Option komplett (inkl. aller Verknüpfungen zu FileTypes)
     * @request DELETE:/api/License/options/{id}
     * @secure
     */
    licenseDeleteLicenseOption: (id: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/License/options/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetLicenseOptionUsages
     * @summary Gibt alle FileTypes zurück, die diese Lizenz-Option verwenden
     * @request GET:/api/License/options/{id}/usages
     * @secure
     */
    licenseGetLicenseOptionUsages: (id: string, params: RequestParams = {}) =>
      this.request<LicenseOptionUsageResponse, ProblemDetails>({
        path: `/api/License/options/${id}/usages`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetFileTypeLicenseOptions
     * @summary Gibt alle Lizenz-Optionen für einen FileType zurück
     * @request GET:/api/License/filetypes/{fileTypeId}/options
     * @secure
     */
    licenseGetFileTypeLicenseOptions: (fileTypeId: string, params: RequestParams = {}) =>
      this.request<FileTypeLicenseOptionResponse[], any>({
        path: `/api/License/filetypes/${fileTypeId}/options`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseAddLicenseOptionToFileType
     * @summary Verknüpft eine Lizenz-Option mit einem FileType
     * @request POST:/api/License/filetypes/{fileTypeId}/options
     * @secure
     */
    licenseAddLicenseOptionToFileType: (
      fileTypeId: string,
      data: AddLicenseOptionToFileTypeRequest,
      params: RequestParams = {},
    ) =>
      this.request<FileTypeLicenseOptionResponse, any>({
        path: `/api/License/filetypes/${fileTypeId}/options`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags License
 * @name LicenseRemoveLicenseOptionFromFileType
 * @summary Entfernt die Verknüpfung zwischen FileType und Lizenz-Option
Wenn die Option nach dem Entfernen nicht mehr von anderen FileTypes verwendet wird, wird sie automatisch gelöscht
 * @request DELETE:/api/License/options/link/{id}
 * @secure
 */
    licenseRemoveLicenseOptionFromFileType: (id: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/License/options/link/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseUpdateFileTypeLicenseOption
     * @summary Aktualisiert eine Lizenz-Option für einen FileType (z.B. Default-Wert, IsRequired)
     * @request PUT:/api/License/options/link/{id}
     * @secure
     */
    licenseUpdateFileTypeLicenseOption: (
      id: string,
      data: UpdateFileTypeLicenseOptionRequest,
      params: RequestParams = {},
    ) =>
      this.request<FileTypeLicenseOptionResponse, ProblemDetails>({
        path: `/api/License/options/link/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseCreateDeviceLicense
     * @summary Erstellt eine neue Lizenz für ein Device
     * @request POST:/api/License/devices/{deviceId}/licenses
     * @secure
     */
    licenseCreateDeviceLicense: (deviceId: string, data: CreateFileTypeLicenseRequest, params: RequestParams = {}) =>
      this.request<FileTypeLicenseResponse, any>({
        path: `/api/License/devices/${deviceId}/licenses`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetDeviceLicenses
     * @summary Gibt alle Lizenzen eines Devices zurück
     * @request GET:/api/License/devices/{deviceId}/licenses
     * @secure
     */
    licenseGetDeviceLicenses: (deviceId: string, params: RequestParams = {}) =>
      this.request<FileTypeLicenseResponse[], ProblemDetails>({
        path: `/api/License/devices/${deviceId}/licenses`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseRequestDeviceLicense
     * @summary Fragt eine neue Lizenz für ein Device an (für Kunden)
     * @request POST:/api/License/devices/{deviceId}/license-requests
     * @secure
     */
    licenseRequestDeviceLicense: (deviceId: string, data: CreateFileTypeLicenseRequest, params: RequestParams = {}) =>
      this.request<FileTypeLicenseResponse, ProblemDetails>({
        path: `/api/License/devices/${deviceId}/license-requests`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseCreateDraftLicense
     * @summary Erstellt eine Lizenz als Entwurf (Draft) für einen Kunden
     * @request POST:/api/License/devices/{deviceId}/licenses/draft
     * @secure
     */
    licenseCreateDraftLicense: (deviceId: string, data: CreateFileTypeLicenseRequest, params: RequestParams = {}) =>
      this.request<FileTypeLicenseResponse, ProblemDetails>({
        path: `/api/License/devices/${deviceId}/licenses/draft`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseSubmitDraftLicense
     * @summary Überführt eine Draft-Lizenz in den Requested-Status (Bestellung)
     * @request POST:/api/License/devices/{deviceId}/licenses/{licenseId}/submit
     * @secure
     */
    licenseSubmitDraftLicense: (deviceId: string, licenseId: string, params: RequestParams = {}) =>
      this.request<FileTypeLicenseResponse[], ProblemDetails>({
        path: `/api/License/devices/${deviceId}/licenses/${licenseId}/submit`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseSubmitAllDraftLicenses
     * @summary Überführt alle Draft-Lizenzen eines Devices in den Requested-Status (Bestellung)
     * @request POST:/api/License/devices/{deviceId}/licenses/submitAll
     * @secure
     */
    licenseSubmitAllDraftLicenses: (deviceId: string, params: RequestParams = {}) =>
      this.request<FileTypeLicenseResponse[], ProblemDetails>({
        path: `/api/License/devices/${deviceId}/licenses/submitAll`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetDeviceLicenseCollection
     * @summary Gibt die Lizenzsammlung (Gesamtlizenz) eines Devices zurück
     * @request GET:/api/License/devices/{deviceId}/license-collection
     * @secure
     */
    licenseGetDeviceLicenseCollection: (deviceId: string, params: RequestParams = {}) =>
      this.request<DeviceLicenseCollectionResponse, ProblemDetails>({
        path: `/api/License/devices/${deviceId}/license-collection`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetDeviceLicense
     * @summary Gibt eine spezifische Lizenz eines Devices zurück
     * @request GET:/api/License/devices/{deviceId}/licenses/{licenseId}
     * @secure
     */
    licenseGetDeviceLicense: (deviceId: string, licenseId: string, params: RequestParams = {}) =>
      this.request<FileTypeLicenseResponse, ProblemDetails>({
        path: `/api/License/devices/${deviceId}/licenses/${licenseId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseDeleteDeviceLicense
     * @summary Löscht eine widerrufene Lizenz eines Devices dauerhaft
     * @request DELETE:/api/License/devices/{deviceId}/licenses/{licenseId}
     * @secure
     */
    licenseDeleteDeviceLicense: (deviceId: string, licenseId: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/License/devices/${deviceId}/licenses/${licenseId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseSearchLicenses
     * @summary Sucht Lizenzen nach verschiedenen Kriterien
     * @request GET:/api/License/licenses
     * @secure
     */
    licenseSearchLicenses: (
      query?: {
        /**
         * Optionaler FileType Filter
         * @format guid
         */
        fileTypeId?: string | null;
        /**
         * Optionaler Device Filter
         * @format guid
         */
        deviceId?: string | null;
        /** Optionaler Status Filter */
        status?: FileTypeLicenseStatus | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<FileTypeLicenseResponse[], any>({
        path: `/api/License/licenses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetRequestedLicenses
     * @summary Gibt alle aktuell angefragten Lizenzen zurück (Status: Requested)
     * @request GET:/api/License/licenses/requested
     * @secure
     */
    licenseGetRequestedLicenses: (params: RequestParams = {}) =>
      this.request<FileTypeLicenseResponse[], any>({
        path: `/api/License/licenses/requested`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseRevokeDeviceLicense
     * @summary Widerruft eine Lizenz eines Devices
     * @request POST:/api/License/devices/{deviceId}/licenses/{licenseId}/revoke
     * @secure
     */
    licenseRevokeDeviceLicense: (deviceId: string, licenseId: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/License/devices/${deviceId}/licenses/${licenseId}/revoke`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseApproveDeviceLicense
     * @summary Genehmigt eine angefragte Lizenz (Requested → Approved)
     * @request POST:/api/License/licenses/{licenseId}/approve
     * @secure
     */
    licenseApproveDeviceLicense: (licenseId: string, params: RequestParams = {}) =>
      this.request<FileTypeLicenseResponse, ProblemDetails>({
        path: `/api/License/licenses/${licenseId}/approve`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseRejectDeviceLicense
     * @summary Lehnt eine angefragte Lizenz ab (Requested → Draft)
     * @request POST:/api/License/licenses/{licenseId}/reject
     * @secure
     */
    licenseRejectDeviceLicense: (licenseId: string, data: RejectLicenseRequest, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/License/licenses/${licenseId}/reject`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseDownloadDeviceLicenseCollection
     * @summary Lädt die gesammelte Lizenzdatei für ein Device herunter
     * @request GET:/api/License/devices/{deviceId}/download
     * @secure
     */
    licenseDownloadDeviceLicenseCollection: (deviceId: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/License/devices/${deviceId}/download`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetLicensePublicKey
     * @summary Gibt den Public Key zur Signaturprüfung zurück
     * @request GET:/api/License/public-key
     * @secure
     */
    licenseGetLicensePublicKey: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/License/public-key`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags License
 * @name LicenseRecalculateLicenseServiceUnits
 * @summary Berechnet die Service-Einheiten einer einzelnen Lizenz neu und liefert eine Preview mit Token.
Die Änderung wird erst durch den Confirm-Endpoint persistiert (Token 10 Min gültig).
 * @request POST:/api/License/licenses/{licenseId}/service-units/recalculate
 * @secure
 */
    licenseRecalculateLicenseServiceUnits: (licenseId: string, params: RequestParams = {}) =>
      this.request<LicenseReconciliationPreview, ProblemDetails>({
        path: `/api/License/licenses/${licenseId}/service-units/recalculate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseConfirmLicenseServiceUnits
     * @summary Bestätigt eine Service-Unit-Preview mit Token und persistiert die Werte.
     * @request POST:/api/License/licenses/{licenseId}/service-units/confirm
     * @secure
     */
    licenseConfirmLicenseServiceUnits: (
      licenseId: string,
      data: ConfirmReconciliationRequest,
      params: RequestParams = {},
    ) =>
      this.request<LicenseReconciliationResult, ProblemDetails>({
        path: `/api/License/licenses/${licenseId}/service-units/confirm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags License
 * @name LicenseSetLicenseExcludeFromCalculation
 * @summary Setzt oder entfernt den Ausschluss-Flag einer Lizenz (nur OFFICE).
Ausgenommene Lizenzen werden nicht in die Service-Einheiten-Summe des Vertrags aufgenommen.
 * @request PATCH:/api/License/licenses/{licenseId}/exclude-from-calculation
 * @secure
 */
    licenseSetLicenseExcludeFromCalculation: (
      licenseId: string,
      data: SetLicenseExcludeRequest,
      params: RequestParams = {},
    ) =>
      this.request<FileTypeLicenseResponse, ProblemDetails>({
        path: `/api/License/licenses/${licenseId}/exclude-from-calculation`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags License
 * @name LicenseRecalculateAllServiceUnits
 * @summary Admin-Endpoint: Rechnet alle Lizenz-Snapshots und alle Vertrags-Gesamtsummen neu
(ohne Token) und überschreibt bestehende Werte. Nutzt man nach größeren Rezept-Änderungen
oder zur Initialisierung.
 * @request POST:/api/License/service-units/recalculate-all
 * @secure
 */
    licenseRecalculateAllServiceUnits: (params: RequestParams = {}) =>
      this.request<AdminRecalculateResult, any>({
        path: `/api/License/service-units/recalculate-all`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  fileType = {
    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeGetHostSystems
     * @summary Get list of all valid host systems
     * @request GET:/FileType/HostSystems
     * @secure
     */
    fileTypeGetHostSystems: (params: RequestParams = {}) =>
      this.request<GetHostSystemData[], any>({
        path: `/FileType/HostSystems`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method performs a ```DELETE``` request to the host systems database. The host system ID is passed as a parameter. The host system is deleted from the database if it exists. If the host system doesn't exist, an error message is returned.
     *
     * @tags FileType
     * @name FileTypeDeleteHostSystem
     * @summary Asynchronously deletes a host system with a specific ID.
     * @request DELETE:/FileType/HostSystem/{id}
     * @secure
     */
    fileTypeDeleteHostSystem: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/FileType/HostSystem/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description This method performs an asynchronous update operation on the host system and returns an ActionResult of GetHostSystemData. It accepts a string 'id' representing the unique identifier of the host system and an 'AddHostSystemData' object.
     *
     * @tags FileType
     * @name FileTypeUpdateHostSystem
     * @summary Updates an existing host system.
     * @request PUT:/FileType/HostSystem/{id}
     * @secure
     */
    fileTypeUpdateHostSystem: (id: string, data: AddHostSystemData, params: RequestParams = {}) =>
      this.request<GetHostSystemData, any>({
        path: `/FileType/HostSystem/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Post operation is asynchronous and the result of the request returns an ActionResult`1 where TResult is GetHostSystemData.
     *
     * @tags FileType
     * @name FileTypeAddHostSystem
     * @summary Adds a new host system asynchronous.
     * @request POST:/FileType/HostSystem
     * @secure
     */
    fileTypeAddHostSystem: (data: AddHostSystemData, params: RequestParams = {}) =>
      this.request<GetHostSystemData, any>({
        path: `/FileType/HostSystem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeGetFileTypes
     * @summary An HTTP GET endpoint that retrieves a list of file types.
     * @request GET:/FileType/FileType
     * @secure
     */
    fileTypeGetFileTypes: (
      query?: {
        /**
         * DEPRECATED: Filter by FileTypeClass (use documentationFilter instead)
         * @default "UNDEFINED"
         */
        variant?: FileTypeClass;
        /** Filter by specific HostSystem IDs */
        system?: string[] | null;
        /**
         * Filter for documentation HostSystems. Default: All
         * @default "All"
         */
        documentationFilter?: DocumentationFilter;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetFileTypeData[], any>({
        path: `/FileType/FileType`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method specifically targets the addition of a new file type into the system. Use this method carefully to avoid duplications or invalid data in the system.
     *
     * @tags FileType
     * @name FileTypeAddFileType
     * @summary This method allows to add a file type.
     * @request POST:/FileType/FileType
     * @secure
     */
    fileTypeAddFileType: (data: AddFileTypeData, params: RequestParams = {}) =>
      this.request<GetFileTypeData, any>({
        path: `/FileType/FileType`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeGetFileTypesPublic
     * @summary An HTTP GET endpoint that retrieves a list of file types.
     * @request GET:/FileType/FileType/Public
     * @secure
     */
    fileTypeGetFileTypesPublic: (
      query?: {
        /**
         * DEPRECATED: Filter by FileTypeClass (use documentationFilter instead)
         * @default "UNDEFINED"
         */
        variant?: FileTypeClass;
        /**
         * Filter for documentation HostSystems. Default: All
         * @default "All"
         */
        documentationFilter?: DocumentationFilter;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetFileTypeData[], any>({
        path: `/FileType/FileType/Public`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeGetFileTypePublic
     * @summary An HTTP GET endpoint that retrieves a list of file types.
     * @request GET:/FileType/FileType/Public/{id}
     * @secure
     */
    fileTypeGetFileTypePublic: (id: string, params: RequestParams = {}) =>
      this.request<GetFileTypeData, any>({
        path: `/FileType/FileType/Public/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeGetFileType
     * @summary An HTTP GET endpoint that retrieves a list of file types.
     * @request GET:/FileType/FileType/{id}
     * @secure
     */
    fileTypeGetFileType: (id: string, params: RequestParams = {}) =>
      this.request<GetFileTypeData, any>({
        path: `/FileType/FileType/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This is an asynchronous operation that deletes a specific file type based on the provided ID.
     *
     * @tags FileType
     * @name FileTypeDeleteFileType
     * @summary Deletes a specific file type.
     * @request DELETE:/FileType/FileType/{id}
     * @secure
     */
    fileTypeDeleteFileType: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/FileType/FileType/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description This method will edit existing file type data in the system.
     *
     * @tags FileType
     * @name FileTypeEditFileType
     * @summary Edits the file type data.
     * @request PUT:/FileType/FileType/{id}
     * @secure
     */
    fileTypeEditFileType: (id: string, data: AddFileTypeData, params: RequestParams = {}) =>
      this.request<GetFileTypeData, any>({
        path: `/FileType/FileType/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeGetFileTypeVersions
     * @summary Get versions that contain files for a file type.
     * @request GET:/FileType/FileType/{fileTypeId}/Versions
     * @secure
     */
    fileTypeGetFileTypeVersions: (
      fileTypeId: string,
      query?: {
        /**
         * Filter for documentation HostSystems. Default: All
         * @default "All"
         */
        documentationFilter?: DocumentationFilter;
        /**
         * Maximum number of versions to return. Default: 3
         * @format int32
         * @default 3
         */
        maxVersions?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetVersionFileData[], any>({
        path: `/FileType/FileType/${fileTypeId}/Versions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method requires the caller to be authorized with the "ADMIN" user group.
     *
     * @tags FileType
     * @name FileTypeUpdateFileTypes
     * @summary Updates the file types for a specific file.
     * @request POST:/FileType/FileType/{fileTypeId}/HostSystem/{hostSystemId}/MatchingFiles
     * @secure
     */
    fileTypeUpdateFileTypes: (fileTypeId: string, hostSystemId: string, data: string[], params: RequestParams = {}) =>
      this.request<GetFileTypeData, any>({
        path: `/FileType/FileType/${fileTypeId}/HostSystem/${hostSystemId}/MatchingFiles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeGetScreenshots
     * @summary Gets the list of screenshots for a specific file type.
     * @request GET:/FileType/FileType/{fileTypeId}/Screenshots
     * @secure
     */
    fileTypeGetScreenshots: (fileTypeId: string, params: RequestParams = {}) =>
      this.request<ImageDto[], any>({
        path: `/FileType/FileType/${fileTypeId}/Screenshots`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeAddLogo
     * @summary Adds a logo to a specific file type.
     * @request POST:/FileType/FileType/{fileTypeId}/Logo
     * @secure
     */
    fileTypeAddLogo: (
      fileTypeId: string,
      data: {
        /** @format binary */
        File?: File | null;
        Description?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<ImageDto, any>({
        path: `/FileType/FileType/${fileTypeId}/Logo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeGetLogo
     * @summary Adds a logo to a specific file type.
     * @request GET:/FileType/FileType/{fileTypeId}/Logo
     * @secure
     */
    fileTypeGetLogo: (fileTypeId: string, params: RequestParams = {}) =>
      this.request<ImageDto, any>({
        path: `/FileType/FileType/${fileTypeId}/Logo`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeAddScreenshot
     * @summary Adds a screenshot to a specific file type.
     * @request POST:/FileType/FileType/{fileTypeId}/Screenshot
     * @secure
     */
    fileTypeAddScreenshot: (
      fileTypeId: string,
      data: {
        /** @format binary */
        File?: File | null;
        Description?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<ImageDto, any>({
        path: `/FileType/FileType/${fileTypeId}/Screenshot`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeEditImageDescription
     * @summary Edits the description of a specific image.
     * @request PUT:/FileType/FileType/Image/{imageId}/Description
     * @secure
     */
    fileTypeEditImageDescription: (imageId: string, data: string, params: RequestParams = {}) =>
      this.request<ImageDto, any>({
        path: `/FileType/FileType/Image/${imageId}/Description`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeDeleteImage
     * @summary Deletes a specific image.
     * @request DELETE:/FileType/FileType/Image/{imageId}
     * @secure
     */
    fileTypeDeleteImage: (imageId: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/FileType/FileType/Image/${imageId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeGetImageDataRaw
     * @summary Gets a specific image by its ID and serves it as a direct file response.
     * @request GET:/FileType/Image/{imageId}
     * @secure
     */
    fileTypeGetImageDataRaw: (imageId: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/FileType/Image/${imageId}`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  filterTags = {
    /**
     * No description
     *
     * @tags FilterTags
     * @name FilterTagsListFilterTags
     * @summary Lists all filter tags
     * @request GET:/FilterTags
     * @secure
     */
    filterTagsListFilterTags: (params: RequestParams = {}) =>
      this.request<GetFilterTagData[], any>({
        path: `/FilterTags`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FilterTags
     * @name FilterTagsAddFilterTag
     * @summary Add new filter tag
     * @request POST:/FilterTags
     * @secure
     */
    filterTagsAddFilterTag: (data: AddFilterTagData, params: RequestParams = {}) =>
      this.request<any, BadRequestResponse>({
        path: `/FilterTags`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  gdbService = {
    /**
     * No description
     *
     * @tags GdbService
     * @name GdbServicePing
     * @summary Gdb Service sends a "Ping" to the SupportServer to show it is alive
     * @request POST:/GdbService/ping
     * @secure
     */
    gdbServicePing: (data: GdbServicePing, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/GdbService/ping`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description This endpoint is accessible only from local IP addresses as defined by the "LocalIpPolicy". It allows uploading results for a core dump that has been initiated by the SupportServer.
     *
     * @tags GdbService
     * @name GdbServiceUploadGdbResult
     * @summary Receives and processes GDB MI records associated with a specific core dump.
     * @request POST:/GdbService/{id}/processed
     * @secure
     */
    gdbServiceUploadGdbResult: (id: string, data: GdbMiRecord[], params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/GdbService/${id}/processed`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description This endpoint should be called when an error occurs on a machine during the processing of a core dump. It logs the error message in the database associated with the specific core dump ID.
     *
     * @tags GdbService
     * @name GdbServiceLogGdbError
     * @summary Logs an error associated with a specific core dump.
     * @request POST:/GdbService/{id}/processed/error
     * @secure
     */
    gdbServiceLogGdbError: (id: string, data: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/GdbService/${id}/processed/error`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description This method requires the "Development" user group authorization.
     *
     * @tags GdbService
     * @name GdbServiceGetServiceBuilds
     * @summary Gets a list of service builds for a given service.
     * @request GET:/GdbService/{name}/builds
     * @secure
     */
    gdbServiceGetServiceBuilds: (name: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/GdbService/${name}/builds`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GdbService
     * @name GdbServiceGetArtifacts
     * @request GET:/GdbService/{name}/builds/{id}/artifacts
     * @secure
     */
    gdbServiceGetArtifacts: (name: string, id: number, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/GdbService/${name}/builds/${id}/artifacts`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GdbService
     * @name GdbServiceRunGdbProcess
     * @summary Runs a GDB process on the specified GDB service.
     * @request POST:/GdbService/run-gdb-process
     * @secure
     */
    gdbServiceRunGdbProcess: (
      data: File,
      query?: {
        Command?: string | null;
        Interpreter?: string | null;
        FileName?: string;
        /** @format int32 */
        BuildId?: number | null;
        BuildType?: string | null;
        Debug?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, ProblemDetails>({
        path: `/GdbService/run-gdb-process`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GdbService
     * @name GdbServiceListResults
     * @summary Retrieves a list of core dump results.
     * @request GET:/GdbService/results
     * @secure
     */
    gdbServiceListResults: (
      query?: {
        /**
         * If true, only returns results that are marked as successfully finished. Defaults to true.
         * @default true
         */
        onlyFinished?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCoreDumpDTO[], any>({
        path: `/GdbService/results`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint is accessible only to users with the DEVELOPMENT user group.
     *
     * @tags GdbService
     * @name GdbServiceGetResultById
     * @summary Gets the core dump result by ID.
     * @request GET:/GdbService/results/{id}
     * @secure
     */
    gdbServiceGetResultById: (id: string, params: RequestParams = {}) =>
      this.request<GetCoreDumpDTO, any>({
        path: `/GdbService/results/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint is accessible only to users with the DEVELOPMENT user group.
     *
     * @tags GdbService
     * @name GdbServiceDeleteCoreDumpById
     * @summary Gets the core dump result by ID.
     * @request DELETE:/GdbService/results/{id}
     * @secure
     */
    gdbServiceDeleteCoreDumpById: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/GdbService/results/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description This method checks if the specified ID exists in the CoreDump table and if the corresponding record is marked as finished. It then attempts to read the associated JSON file, which contains the details of the core dump, and returns its content as a list of GdbMiRecord objects.
     *
     * @tags GdbService
     * @name GdbServiceGetResultDataById
     * @summary Retrieves the details of a specific core dump result by its unique identifier.
     * @request GET:/GdbService/results/{id}/data
     * @secure
     */
    gdbServiceGetResultDataById: (id: string, params: RequestParams = {}) =>
      this.request<GdbMiRecord[], any>({
        path: `/GdbService/results/${id}/data`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GdbService
     * @name GdbServiceServices
     * @summary Retrieves the services available.
     * @request GET:/GdbService/services
     * @secure
     */
    gdbServiceServices: (params: RequestParams = {}) =>
      this.request<GdbServicePing[], any>({
        path: `/GdbService/services`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  geodata = {
    /**
 * No description
 *
 * @tags Geodata
 * @name GeodataConvertPbfToTiles
 * @summary Converts an uploaded .osm.pbf file to mbtiles or pmtiles using tilemaker.
Temporary files are deleted after the response has been sent.
 * @request POST:/Geodata/ConvertPbfToTiles
 * @secure
 */
    geodataConvertPbfToTiles: (
      data: {
        /** @format binary */
        PbfFile?: File | null;
        OutputFormat?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, ProblemDetails | void>({
        path: `/Geodata/ConvertPbfToTiles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),
  };
  products = {
    /**
     * No description
     *
     * @tags Products
     * @name ProductsGetProducts
     * @summary Get all products.
     * @request GET:/Products
     * @secure
     */
    productsGetProducts: (params: RequestParams = {}) =>
      this.request<GetProductsData[], any>({
        path: `/Products`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name ProductsGetProductByLink
     * @summary Get a specific product by its link.
     * @request GET:/Products/Link/{link}
     * @secure
     */
    productsGetProductByLink: (link: string, params: RequestParams = {}) =>
      this.request<GetProductsData, any>({
        path: `/Products/Link/${link}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name ProductsUploadFileToProduct
     * @summary Uploads a file to a specific product.
     * @request POST:/Products/UploadFile
     * @secure
     */
    productsUploadFileToProduct: (data: File, params: RequestParams = {}) =>
      this.request<FileDataResponse, any>({
        path: `/Products/UploadFile`,
        method: "POST",
        body: data,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name ProductsGetFilesByProductLink
     * @summary Gets all files for a specific product.
     * @request GET:/Products/Files/{productLink}
     * @secure
     */
    productsGetFilesByProductLink: (productLink: string, params: RequestParams = {}) =>
      this.request<FileDataResponse[], any>({
        path: `/Products/Files/${productLink}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  service = {
    /**
     * No description
     *
     * @tags Service
     * @name ServiceGeneratePassword
     * @summary This method is used to generate a password.
     * @request POST:/Service/password/generate
     * @secure
     */
    serviceGeneratePassword: (data: ResolveServiceData, params: RequestParams = {}) =>
      this.request<GetServiceData, any>({
        path: `/Service/password/generate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service
     * @name ServiceGetLicenseVersions
     * @request GET:/Service/licenses/versions
     * @secure
     */
    serviceGetLicenseVersions: (params: RequestParams = {}) =>
      this.request<FileTypeLicenseDto[], any>({
        path: `/Service/licenses/versions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method requires the user to be in the DEVELOPMENT user group.
     *
     * @tags Service
     * @name ServiceGenerateLicenceKey
     * @summary Generates a license key for the specified host and mode.
     * @request GET:/Service/licenses/generate-key
     * @secure
     */
    serviceGenerateLicenceKey: (
      query?: {
        /** The identifier of the host for which the license key is to be generated. */
        hostId?: string;
        /**
         * The product identifier (FileType ID).
         * @format guid
         */
        product?: string;
        /** Optional variant of the product. */
        variant?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/Service/licenses/generate-key`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service
     * @name ServiceGenerateAndStoreLicense
     * @request POST:/Service/licenses/{requestId}/generate
     * @secure
     */
    serviceGenerateAndStoreLicense: (requestId: string, params: RequestParams = {}) =>
      this.request<LicenseResponseDto, any>({
        path: `/Service/licenses/${requestId}/generate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service
     * @name ServiceRequestLicense
     * @request POST:/Service/licenses/request
     * @secure
     */
    serviceRequestLicense: (data: RequestsLicenseDto, params: RequestParams = {}) =>
      this.request<LicenseResponseDto, any>({
        path: `/Service/licenses/request`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service
     * @name ServiceGetAllRequestedLicenses
     * @request GET:/Service/licenses/requested
     * @secure
     */
    serviceGetAllRequestedLicenses: (params: RequestParams = {}) =>
      this.request<LicenseResponseDto[], any>({
        path: `/Service/licenses/requested`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service
     * @name ServiceGetLicensesBySupportId
     * @request GET:/Service/licenses/support/{supportId}
     * @secure
     */
    serviceGetLicensesBySupportId: (supportId: string, params: RequestParams = {}) =>
      this.request<LicenseResponseDto[], any>({
        path: `/Service/licenses/support/${supportId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service
     * @name ServiceOrderLicenses
     * @summary Orders licenses in the shopping cart based on a list of IDs.
     * @request POST:/Service/licenses/order
     * @secure
     */
    serviceOrderLicenses: (data: string[], params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Service/licenses/order`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service
     * @name ServiceOrderLicense
     * @summary Orders licenses in the shopping cart based on a list of IDs.
     * @request POST:/Service/licenses/{licenseId}/order
     * @secure
     */
    serviceOrderLicense: (licenseId: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Service/licenses/${licenseId}/order`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service
     * @name ServiceRevokeLicense
     * @summary Revokes the specified license.
     * @request POST:/Service/licenses/{licenseId}/revoke
     * @secure
     */
    serviceRevokeLicense: (licenseId: string, params: RequestParams = {}) =>
      this.request<LicenseResponseDto, any>({
        path: `/Service/licenses/${licenseId}/revoke`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service
     * @name ServiceRejectLicense
     * @summary Rejects the specified license.
     * @request POST:/Service/licenses/{licenseId}/reject
     * @secure
     */
    serviceRejectLicense: (licenseId: string, params: RequestParams = {}) =>
      this.request<LicenseResponseDto, any>({
        path: `/Service/licenses/${licenseId}/reject`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service
     * @name ServiceDeleteLicense
     * @summary Deletes the specified license.
     * @request DELETE:/Service/licenses/{licenseId}
     * @secure
     */
    serviceDeleteLicense: (licenseId: string, params: RequestParams = {}) =>
      this.request<LicenseResponseDto, any>({
        path: `/Service/licenses/${licenseId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Service
 * @name ServiceUpdateLicense
 * @summary Updates (remaps) an existing license request to a different product/variant.
Only allowed for licenses that haven't been generated yet (InCart or Ordered status).
 * @request PUT:/Service/licenses/{licenseId}
 * @secure
 */
    serviceUpdateLicense: (licenseId: string, data: UpdateLicenseDto, params: RequestParams = {}) =>
      this.request<LicenseResponseDto, any>({
        path: `/Service/licenses/${licenseId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Service
 * @name ServiceRevokeAndRemapLicense
 * @summary Revokes an already generated license and creates a new license with corrected product/variant.
This is used when a customer made a mistake and needs to change an already issued license.
The old license will be revoked, and a new license will be created and immediately generated
with the same parameters (HostId, SupportCodeId, Description, UserId) but with the new FileTypeId and Tag.
 * @request PUT:/Service/licenses/{licenseId}/revoke-and-remap
 * @secure
 */
    serviceRevokeAndRemapLicense: (licenseId: string, data: UpdateLicenseDto, params: RequestParams = {}) =>
      this.request<LicenseResponseDto, any>({
        path: `/Service/licenses/${licenseId}/revoke-and-remap`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  supportCode = {
    /**
     * @description This method retrieves support codes accessible to the authenticated user. Customers can only see their own support codes, while admins can see all.
     *
     * @tags SupportCode
     * @name SupportCodeListSupportCodes
     * @summary Lists the support codes.
     * @request GET:/SupportCode
     * @secure
     */
    supportCodeListSupportCodes: (params: RequestParams = {}) =>
      this.request<GetSupportCodeData[], any>({
        path: `/SupportCode`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This function accepts a data model via HTTP POST method to introduce a new support code into the system. It is vital that the data model contains all necessary details for the creation of a support code. If the provided contract is not found in the system, it will return an EntityNotFound result.
     *
     * @tags SupportCode
     * @name SupportCodeAddSupportCode
     * @summary Creates and adds a new support code into the system.
     * @request POST:/SupportCode
     * @secure
     */
    supportCodeAddSupportCode: (data: AddSupportCodeData, params: RequestParams = {}) =>
      this.request<GetSupportCodeData, NotFoundResponse>({
        path: `/SupportCode`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This method is used to quickly get support based on the provided data. It's an asynchronous operation and allows anonymous access.
     *
     * @tags SupportCode
     * @name SupportCodeQuickSupport
     * @summary This is the QuickSupport action method in the Controller
     * @request GET:/SupportCode/quicksupport
     * @secure
     */
    supportCodeQuickSupport: (
      query?: {
        /**
         * The data based on which support is provided. This could be an issue description or relevant
         * code/conditions to troubleshoot.
         *
         */
        data?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetQuickSupportData, NotFoundResponse>({
        path: `/SupportCode/quicksupport`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SupportCode
     * @name SupportCodeGetSupportCode
     * @summary An HTTP GET endpoint that retrieves support code data associated with the provided `id`.
     * @request GET:/SupportCode/{id}
     * @secure
     */
    supportCodeGetSupportCode: (id: string, params: RequestParams = {}) =>
      this.request<GetSupportCodeData, NotFoundResponse>({
        path: `/SupportCode/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Use this method to delete the specific support code from the system. This operation will only be successful if the logged-in user is a super admin. Once the support code is deleted, the operation cannot be undone.
     *
     * @tags SupportCode
     * @name SupportCodeDeleteSupportCode
     * @summary Deletes the specified support code.
     * @request DELETE:/SupportCode/{id}
     * @secure
     */
    supportCodeDeleteSupportCode: (id: string, params: RequestParams = {}) =>
      this.request<boolean, BadRequestResponse | NotFoundResponse>({
        path: `/SupportCode/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: POST /QuickSupport/Create { "Parameter1": "value", "Parameter2": "value" }
     *
     * @tags SupportCode
     * @name SupportCodeCreateQuickSupport
     * @summary Initiates a request for Quick Support
     * @request POST:/SupportCode/QuickSupport/Create
     * @secure
     */
    supportCodeCreateQuickSupport: (
      data: {
        Title?: string;
        Name?: string;
        EMail?: string;
        Phone?: string | null;
        /** @format int32 */
        RequestType?: number;
        SystemId?: string | null;
        CurrentVersion?: string;
        HostId?: string | null;
        SystemName?: string | null;
        SupportContractId?: string | null;
        ReCaptchaToken?: string | null;
        SelectedDSGVO?: boolean;
        SelectedPaySelf?: boolean | null;
        SelectedPayOwner?: boolean | null;
        SelectedIsGuarantee?: boolean | null;
        Text?: string;
        /** @format binary */
        File?: File | null;
        /** @format binary */
        CoreDump?: File | null;
        TestMessage?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, BadRequestResponse>({
        path: `/SupportCode/QuickSupport/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SupportCode
     * @name SupportCodeGetValuesForField
     * @request GET:/SupportCode/QuickSupport/Field/{fieldId}
     * @secure
     */
    supportCodeGetValuesForField: (fieldId: string, params: RequestParams = {}) =>
      this.request<string, BadRequestResponse>({
        path: `/SupportCode/QuickSupport/Field/${fieldId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  supportContract = {
    /**
     * No description
     *
     * @tags SupportContract
     * @name SupportContractListSupportContracts
     * @summary An HTTP GET endpoint that retrieves a list of support contracts.
     * @request GET:/SupportContract
     * @secure
     */
    supportContractListSupportContracts: (
      query?: {
        /** Optional: Filter by Support Code ID (partial match) */
        supportCodeId?: string | null;
        /** Optional: Filter by Customer ID (partial match) */
        customerId?: string | null;
        /** Optional: Filter by Customer Name (partial match) */
        customerName?: string | null;
        /** Optional: General search across all fields (Support Code ID, Customer ID, Customer Name) */
        searchTerm?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetSupportContractData[], any>({
        path: `/SupportContract`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method is decorated with the HttpPost attribute, indicating that it is intended to handle HTTP POST requests. Any data necessary for the creation of the support contract needs to be included in the request body (as the parameter of type AddSupportContractData).
     *
     * @tags SupportContract
     * @name SupportContractAddSupportContract
     * @summary This method is intended to add a new support contract using the provided data.
     * @request POST:/SupportContract
     * @secure
     */
    supportContractAddSupportContract: (data: AddSupportContractData, params: RequestParams = {}) =>
      this.request<GetSupportContractData, any>({
        path: `/SupportContract`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SupportContract
     * @name SupportContractGetSummary
     * @summary Retrieves a summary of support contracts grouped by status.
     * @request GET:/SupportContract/summary
     * @secure
     */
    supportContractGetSummary: (
      query?: {
        /**
         * Window in days for expiring contracts.
         * @format int32
         * @default 30
         */
        expiringSoonDays?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SupportContractSummaryDto, any>({
        path: `/SupportContract/summary`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SupportContract
     * @name SupportContractCreateNewContact
     * @summary Create new contact in external system. Contacts need to belong to support contracts
     * @request POST:/SupportContract/contact
     * @secure
     */
    supportContractCreateNewContact: (data: CreateContactData, params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/SupportContract/contact`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SupportContract
     * @name SupportContractRemewContract
     * @summary Create new contact in external system. Contacts need to belong to support contracts
     * @request POST:/SupportContract/contact/renew
     * @secure
     */
    supportContractRemewContract: (
      query?: {
        contract?: string;
        /** @format int32 */
        duration?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<number, any>({
        path: `/SupportContract/contact/renew`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This API will return the entire support contract data, including all its related details.
     *
     * @tags SupportContract
     * @name SupportContractGetSupportContract
     * @summary Asynchronously gets the support contract data for a specific id.
     * @request GET:/SupportContract/{id}
     * @secure
     */
    supportContractGetSupportContract: (id: string, params: RequestParams = {}) =>
      this.request<GetSupportContractData, any>({
        path: `/SupportContract/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This API has a DELETE method signature and will respond with a boolean indicating the outcome of the deletion operation.
     *
     * @tags SupportContract
     * @name SupportContractDeleteSupportContract
     * @summary Deletes a support contract.
     * @request DELETE:/SupportContract/{id}
     * @secure
     */
    supportContractDeleteSupportContract: (id: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/SupportContract/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method will update the support contract information in the database, including setting a new expiration date. If the contract does not exist, it will return a NotFoundResult.
     *
     * @tags SupportContract
     * @name SupportContractRenewSupportContract
     * @summary Renews a support contract.
     * @request POST:/SupportContract/{id}/Renew
     * @secure
     */
    supportContractRenewSupportContract: (
      id: string,
      query?: {
        /**
         * A DateOnly instance representing the new expiration date of the contract.
         * This value is required.
         *
         * @format date
         */
        expire?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetSupportContractData, any>({
        path: `/SupportContract/${id}/Renew`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The users returned are only those associated with the specific support contract identified by the given ID. If no such contract exists, or if it has no associated users, the method will return an empty list.
     *
     * @tags SupportContract
     * @name SupportContractGetSupportContractUsers
     * @summary Fetches a list of users associated with a given support contract.
     * @request GET:/SupportContract/{id}/Users
     * @secure
     */
    supportContractGetSupportContractUsers: (id: string, params: RequestParams = {}) =>
      this.request<GetUserData[], any>({
        path: `/SupportContract/${id}/Users`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This controller action handles the addition of a user to a specified support contract by their respective identifiers.
     *
     * @tags SupportContract
     * @name SupportContractAddUserToSupportContract
     * @summary Adds a user to the support contract by the provided IDs.
     * @request POST:/SupportContract/{id}/Users/{userid}
     * @secure
     */
    supportContractAddUserToSupportContract: (id: string, userid: string, params: RequestParams = {}) =>
      this.request<GetUserData[], any>({
        path: `/SupportContract/${id}/Users/${userid}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method removes a specific user from a specified support contract.
     *
     * @tags SupportContract
     * @name SupportContractRemoveUserToSupportContract
     * @summary Removes a user from a support contract.
     * @request DELETE:/SupportContract/{id}/Users/{userid}
     * @secure
     */
    supportContractRemoveUserToSupportContract: (id: string, userid: string, params: RequestParams = {}) =>
      this.request<GetUserData[], any>({
        path: `/SupportContract/${id}/Users/${userid}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method executes asynchronously and is accessible via an HTTP GET request.
     *
     * @tags SupportContract
     * @name SupportContractGetSupportCodes
     * @summary Fetches a list of GetSupportCodeData instances associated with a specified ID.
     * @request GET:/SupportContract/{id}/SupportCodes
     * @secure
     */
    supportContractGetSupportCodes: (id: string, params: RequestParams = {}) =>
      this.request<GetSupportCodeData[], any>({
        path: `/SupportContract/${id}/SupportCodes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This function can be accessed using the HttpGET method and the Sync route. The function calls the ReadFromExternal method on the _supportContractService object. This ReadFromExternal method is responsible for reading data from an external source. The function is asynchronous, meaning it runs in the background and does not block the main application thread.
     *
     * @tags SupportContract
     * @name SupportContractSync
     * @summary This function performs synchronization with the external source.
     * @request GET:/SupportContract/Sync
     * @secure
     */
    supportContractSync: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/SupportContract/Sync`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SupportContract
     * @name SupportContractGetAllContractServiceUnits
     * @summary Liefert die Service-Einheiten-Snapshots aller Support-Verträge (für Listenansicht).
     * @request GET:/SupportContract/service-units
     * @secure
     */
    supportContractGetAllContractServiceUnits: (
      query?: {
        /**
         * Wenn true, nur Verträge deren Snapshot veraltet ist
         * @default false
         */
        staleOnly?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<SupportContractServiceUnitsResponse[], any>({
        path: `/SupportContract/service-units`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SupportContract
     * @name SupportContractGetContractServiceUnits
     * @summary Liefert die Service-Einheiten-Info eines Support-Vertrags (nur persistierter Snapshot).
     * @request GET:/SupportContract/{id}/service-units
     * @secure
     */
    supportContractGetContractServiceUnits: (id: string, params: RequestParams = {}) =>
      this.request<SupportContractServiceUnitsResponse, ProblemDetails>({
        path: `/SupportContract/${id}/service-units`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags SupportContract
 * @name SupportContractRecalculateContractServiceUnits
 * @summary Berechnet die Service-Einheiten eines Support-Vertrags neu und liefert eine Preview
mit Token. Die Werte werden erst durch den Confirm-Endpoint persistiert (Token 10 Min gültig).
 * @request POST:/SupportContract/{id}/service-units/recalculate
 * @secure
 */
    supportContractRecalculateContractServiceUnits: (id: string, params: RequestParams = {}) =>
      this.request<ContractReconciliationPreview, ProblemDetails>({
        path: `/SupportContract/${id}/service-units/recalculate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SupportContract
     * @name SupportContractConfirmContractServiceUnits
     * @summary Bestätigt eine Service-Unit-Preview mit Token und persistiert Lizenz-Snapshots + Vertrags-Total.
     * @request POST:/SupportContract/{id}/service-units/confirm
     * @secure
     */
    supportContractConfirmContractServiceUnits: (
      id: string,
      data: ConfirmReconciliationRequest,
      params: RequestParams = {},
    ) =>
      this.request<ContractReconciliationResult, ProblemDetails>({
        path: `/SupportContract/${id}/service-units/confirm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  teamCity = {
    /**
     * No description
     *
     * @tags TeamCity
     * @name TeamCityTeamCityBuilds
     * @request GET:/TeamCity
     * @secure
     */
    teamCityTeamCityBuilds: (params: RequestParams = {}) =>
      this.request<GetBuildsDto[], any>({
        path: `/TeamCity`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TeamCity
     * @name TeamCityTeamCityArtifacts
     * @request GET:/TeamCity/{id}
     * @secure
     */
    teamCityTeamCityArtifacts: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/TeamCity/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TeamCity
     * @name TeamCityDownloadFile
     * @request POST:/TeamCity/download
     * @secure
     */
    teamCityDownloadFile: (data: FileDownloadDto, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/TeamCity/download`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  terms = {
    /**
     * No description
     *
     * @tags Terms
     * @name TermsGetLatestTerms
     * @summary Description for the GetLatestTerms action method
     * @request GET:/Terms/latest
     * @secure
     */
    termsGetLatestTerms: (params: RequestParams = {}) =>
      this.request<GetTermsData, any>({
        path: `/Terms/latest`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This action takes an AddTermsData object and replaces the existing terms with the new values provided. The new terms data is returned after the operation is completed.
     *
     * @tags Terms
     * @name TermsReplaceTerms
     * @summary Retrieves terms data by replacing existing terms with new ones.
     * @request POST:/Terms
     * @secure
     */
    termsReplaceTerms: (data: AddTermsData, params: RequestParams = {}) =>
      this.request<GetTermsData, any>({
        path: `/Terms`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  user = {
    /**
     * No description
     *
     * @tags User
     * @name UserSignUp
     * @summary An HTTP POST endpoint that registers a new user.
     * @request POST:/User/SignUp
     * @secure
     */
    userSignUp: (data: RegisterUserData, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/User/SignUp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserAlive
     * @request GET:/User/Alive
     * @secure
     */
    userAlive: (params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/User/Alive`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserSignIn
     * @summary An HTTP POST endpoint that allows a new user to sign up for the application.
     * @request POST:/User/SignIn
     * @secure
     */
    userSignIn: (
      query?: {
        /** The username of the user who wants to sign up. */
        username?: string;
        /** The password of the user who wants to sign up. */
        password?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SignInUserData, any>({
        path: `/User/SignIn`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method handles HTTP POST requests at the endpoint: `/Lock/{id}`. It requires the request to be authorized under the User Group named 'OFFICE'.
     *
     * @tags User
     * @name UserLockUser
     * @summary Locks a user by their unique identifier.
     * @request POST:/User/Lock/{id}
     * @secure
     */
    userLockUser: (id: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/User/Lock/${id}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This controller action will return a boolean value determining if the user has accepted the terms.
     *
     * @tags User
     * @name UserAcceptedTerms
     * @summary Checks if current user accepted terms.
     * @request GET:/User/Me/Terms
     * @secure
     */
    userAcceptedTerms: (params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/User/Me/Terms`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint can be accessed by anyone without the need for authentication. It takes a username as a parameter in HTTP body.
     *
     * @tags User
     * @name UserPasswordForgotten
     * @summary Endpoint to trigger the forgotten password functionality.
     * @request POST:/User/PasswordForgotten
     * @secure
     */
    userPasswordForgotten: (data: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/User/PasswordForgotten`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This method is a POST endpoint that allows users to accept the terms. It uses the _userService object and its AcceptTerms method.
     *
     * @tags User
     * @name UserAcceptTerms
     * @summary Accepts the terms.
     * @request POST:/User/Me/Terms/Accept
     * @secure
     */
    userAcceptTerms: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/User/Me/Terms/Accept`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description This method accepts a POST request and requires authorization from the specified user group. Execute this operation with caution as it directly affects the system users. If the operation encounters a BadRequestException, the bad request response will return with a related message. Any other exceptions will also be handled and result in a bad request response.
     *
     * @tags User
     * @name UserAddUser
     * @summary Adds a new user to the system.
     * @request POST:/User
     * @secure
     */
    userAddUser: (data: AddUserData, params: RequestParams = {}) =>
      this.request<GetUserData, any>({
        path: `/User`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This function requires authorization with User Group Names of type OFFICE It returns an ActionResult containing a list of GetUserData objects It makes use of the UserService to fetch the list of users This method is asynchronous and should be awaited for the task to complete
     *
     * @tags User
     * @name UserListUsers
     * @summary This method is used to list all users
     * @request GET:/User
     * @secure
     */
    userListUsers: (params: RequestParams = {}) =>
      this.request<GetUserData[], any>({
        path: `/User`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserResendFirstLogin
     * @summary Resends first login mail with new password if not already logged in
     * @request POST:/User/{id}/ResendFirstLogin
     * @secure
     */
    userResendFirstLogin: (id: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/User/${id}/ResendFirstLogin`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserResendPasswordReset
     * @summary Admin function: Resend password reset email with new temporary password.
     * @request POST:/User/{id}/ResendPasswordReset
     * @secure
     */
    userResendPasswordReset: (id: string, params: RequestParams = {}) =>
      this.request<boolean, string>({
        path: `/User/${id}/ResendPasswordReset`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method is protected by the authorization policy "UserGroupNames.OFFICE".
     *
     * @tags User
     * @name UserEditUser
     * @summary Edits a user by Id.
     * @request PUT:/User/{id}
     * @secure
     */
    userEditUser: (id: string, data: EditUserData, params: RequestParams = {}) =>
      this.request<GetUserData, any>({
        path: `/User/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This method takes user's id as parameter and passes it to the user service to delete the user. Only the users in the OFFICE UserGroup have the authorization to delete a user. It returns a boolean value, true indicating deletion was successful and false indicating otherwise.
     *
     * @tags User
     * @name UserDeleteUser
     * @summary Deletes a user from the system.
     * @request DELETE:/User/{id}
     * @secure
     */
    userDeleteUser: (id: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/User/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The HTTP Get method is used to get the user data. Only authorized users can invoke this method. The method is bound to the route 'api/controller/{id}' where 'id' is a placeholder for the user's ID. Any further specific behavior, performance considerations or limitations can be placed here.
     *
     * @tags User
     * @name UserGetUser
     * @summary This asynchronous method retrieves user data based on the provided user ID.
     * @request GET:/User/{id}
     * @secure
     */
    userGetUser: (id: string, params: RequestParams = {}) =>
      this.request<GetUserData, any>({
        path: `/User/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Uses the UserService to handle the actual password changing process. The task represents ongoing work. The result of the work is a boolean value that corresponds to the success or failure of the update operation.
     *
     * @tags User
     * @name UserChangePassword
     * @summary Changes the password for a user.
     * @request POST:/User/ChangePassword
     * @secure
     */
    userChangePassword: (data: ChangePasswordData, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/User/ChangePassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This method fetches detailed support data tied to a specific user identified by id. For optimal results, ensure that the id parameter is valid and non-null.
     *
     * @tags User
     * @name UserGetSupportUserData
     * @summary Fetches user's support data.
     * @request GET:/User/{id}/SupportData
     * @secure
     */
    userGetSupportUserData: (id: string, params: RequestParams = {}) =>
      this.request<GetSupportUserData, any>({
        path: `/User/${id}/SupportData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  version = {
    /**
     * No description
     *
     * @tags Version
     * @name VersionGetServerVersion
     * @summary Gets the current server version.
     * @request GET:/Version/server-version
     * @secure
     */
    versionGetServerVersion: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Version/server-version`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags Version
 * @name VersionGetRecentVersions
 * @summary Retrieves recent versions across products.
If no versions exist in the time window, the latest versions are returned.
 * @request GET:/Version/recent
 * @secure
 */
    versionGetRecentVersions: (
      query?: {
        /**
         * Number of days to look back.
         * @format int32
         * @default 30
         */
        days?: number;
        /**
         * Maximum number of versions to return.
         * @format int32
         * @default 5
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<RecentVersionDto[], any>({
        path: `/Version/recent`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Version
     * @name VersionGetVersionByKey
     * @summary Gets a single version by key for internal users (OFFICE/DEVELOPMENT).
     * @request POST:/Version/byKey
     * @secure
     */
    versionGetVersionByKey: (data: VersionKey, params: RequestParams = {}) =>
      this.request<GetVersionData, ProblemDetails>({
        path: `/Version/byKey`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Version
     * @name VersionGetVersionByKeyForCustomer
     * @summary Gets a single version by key for customers.
     * @request POST:/Version/Customer/byKey
     * @secure
     */
    versionGetVersionByKeyForCustomer: (data: VersionKey, params: RequestParams = {}) =>
      this.request<GetVersionDataCustomer, ProblemDetails>({
        path: `/Version/Customer/byKey`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This method adds a version
     *
     * @tags Version
     * @name VersionAddVersion
     * @summary Adds version
     * @request POST:/Version
     * @secure
     */
    versionAddVersion: (data: AddVersionData, params: RequestParams = {}) =>
      this.request<GetVersionData, any>({
        path: `/Version`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This method updates a version
     *
     * @tags Version
     * @name VersionUpdateVersion
     * @summary Updates version
     * @request PUT:/Version
     * @secure
     */
    versionUpdateVersion: (data: AddVersionData, params: RequestParams = {}) =>
      this.request<GetVersionData, ProblemDetails>({
        path: `/Version`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This method gets all public versions
     *
     * @tags Version
     * @name VersionGetPublicVersions
     * @summary Gets public versions
     * @request GET:/Version/{link}/public
     * @secure
     */
    versionGetPublicVersions: (link: string, params: RequestParams = {}) =>
      this.request<GetVersionDataPublic[], any>({
        path: `/Version/${link}/public`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method gets all customer versions with optional filtering by host systems
     *
     * @tags Version
     * @name VersionGetCustomerVersions
     * @summary Gets customer versions
     * @request GET:/Version/{link}/customer
     * @secure
     */
    versionGetCustomerVersions: (
      link: string,
      query?: {
        /** Optional list of HostSystem IDs to filter files (OR-linked) */
        hostSystemIds?: string[] | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetVersionDataCustomer[], any>({
        path: `/Version/${link}/customer`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method retrieves all versions
     *
     * @tags Version
     * @name VersionGetVersions
     * @summary Gets all versions
     * @request GET:/Version/{link}
     * @secure
     */
    versionGetVersions: (
      link: string,
      query?: {
        /** Optional list of HostSystem IDs to filter files (OR-linked) */
        hostSystemIds?: string[] | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetVersionData[], any>({
        path: `/Version/${link}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method retrieves all versions
     *
     * @tags Version
     * @name VersionGetVersionsFlat
     * @summary Gets all versions as flat list
     * @request GET:/Version/{link}/Flat
     * @secure
     */
    versionGetVersionsFlat: (
      link: string,
      query?: {
        /** Optional list of HostSystem IDs to filter files (OR-linked) */
        hostSystemIds?: string[] | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetVersionData[], any>({
        path: `/Version/${link}/Flat`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method approves a version
     *
     * @tags Version
     * @name VersionApproveVersion
     * @summary Approve Version
     * @request POST:/Version/approve
     * @secure
     */
    versionApproveVersion: (data: VersionKey, params: RequestParams = {}) =>
      this.request<GetVersionData, ProblemDetails>({
        path: `/Version/approve`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This method revokes a version
     *
     * @tags Version
     * @name VersionRevokeVersion
     * @summary Revokes Version
     * @request DELETE:/Version/approve
     * @secure
     */
    versionRevokeVersion: (data: VersionKey, params: RequestParams = {}) =>
      this.request<GetVersionData, ProblemDetails>({
        path: `/Version/approve`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This method deletes a specific file
     *
     * @tags Version
     * @name VersionDeleteFile
     * @summary Deletes a file
     * @request DELETE:/Version/File/{id}
     * @secure
     */
    versionDeleteFile: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Version/File/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description This method will return a file stream, allowing the client to download the file. The type returned is a FileStreamResult. Use the id parameter to specify the desired file. Requires authorization of a user within the CUSTOMER group.
     *
     * @tags Version
     * @name VersionGetFile
     * @summary Gets the file.
     * @request GET:/Version/File/{id}
     * @secure
     */
    versionGetFile: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Version/File/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Version
     * @name VersionGetFileDetails
     * @summary Get details of single file
     * @request GET:/Version/File/{id}/Details
     * @secure
     */
    versionGetFileDetails: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Version/File/${id}/Details`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Version
     * @name VersionCheckFileBeforeDownload
     * @summary Check file before download to display error messages
     * @request GET:/Version/File/{id}/CheckDownload
     * @secure
     */
    versionCheckFileBeforeDownload: (id: string, params: RequestParams = {}) =>
      this.request<GetFileCheckDownload, any>({
        path: `/Version/File/${id}/CheckDownload`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Version
     * @name VersionSendMailToUsers
     * @summary Send mail to all users which downloaded a file
     * @request POST:/Version/{major}/{minor}/{patch}/Mail
     * @secure
     */
    versionSendMailToUsers: (major: number, minor: number, patch: number, data: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/Version/${major}/${minor}/${patch}/Mail`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This method will validate the request to ensure that it is a valid form-data request and that the Content-Type header contains a boundary. If the request is not valid, an UnsupportedMediaTypeException will be thrown. Any BadRequestException or EntityNotFoundException that are thrown during the processing of the file will be caught and their messages will be returned as the result of the action.
     *
     * @tags Version
     * @name VersionOnPostUpload
     * @summary Handles the upload of a file.
     * @request POST:/Version/File
     * @secure
     */
    versionOnPostUpload: (
      data: File,
      query?: {
        /**
         * The major version number.
         * @format int32
         * @example 3
         */
        Major?: number;
        /**
         * The minor version number.
         * @format int32
         * @example 1
         */
        Minor?: number;
        /**
         * The patch version number.
         * @format int32
         * @example 0
         */
        Patch?: number;
        /**
         * The unique identifier for the product.
         * @format guid
         * @example "3D290374-8689-4856-B5C4-35E0414F66E8"
         */
        ProductId?: string;
        /**
         * FileTypeId of FileType which belongs to this file
         * @format guid
         */
        FileTypeId?: string;
        /**
         * HostSystemId specifies which platform this file is for
         * @format guid
         */
        HostSystemId?: string | null;
        /** Filename of the file uploaded */
        FileName?: string;
        /** File which will be uploaded */
        ContentType?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetVersionFileData, ProblemDetails>({
        path: `/Version/File`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  youTrack = {
    /**
 * No description
 *
 * @tags YouTrack
 * @name YouTrackGetTickets
 * @summary Retrieves a list of YouTrack tickets/issues from the SupportHelpdesk project with basic information (title and status).
Automatically filters tickets based on the authenticated user's email and their associated support contract IDs.
OFFICE users can optionally filter by a different email address.
 * @request GET:/YouTrack/tickets
 * @secure
 */
    youTrackGetTickets: (
      query?: {
        /**
         * Maximum number of tickets to retrieve. Defaults to 100.
         * @format int32
         * @default 100
         */
        top?: number;
        /**
         * Number of tickets to skip for pagination. Defaults to 0.
         * @format int32
         * @default 0
         */
        skip?: number;
        onlyOpen?: boolean | null;
        /** Optional email to filter tickets for (only for OFFICE users). */
        filterEmail?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<YouTrackIssueDTO[], ProblemDetails>({
        path: `/YouTrack/tickets`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags YouTrack
 * @name YouTrackGetStatistics
 * @summary Retrieves statistics for YouTrack tickets.
Includes total open Helpdesk tickets count (only for DEVELOPMENT users).
 * @request GET:/YouTrack/statistics
 * @secure
 */
    youTrackGetStatistics: (
      query?: {
        /**
         * Maximum number of tickets to retrieve. Defaults to 500.
         * @format int32
         * @default 500
         */
        top?: number;
        /**
         * Number of tickets to skip for pagination. Defaults to 0.
         * @format int32
         * @default 0
         */
        skip?: number;
        /** Optional email to filter tickets for (only for OFFICE users). */
        filterEmail?: string | null;
        /**
         * Maximum number of tickets used for response time calculation.
         * @format int32
         * @default 50
         */
        responseSampleLimit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<YouTrackStatisticsDto, ProblemDetails>({
        path: `/YouTrack/statistics`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags YouTrack
 * @name YouTrackGetAllTickets
 * @summary Retrieves ALL non-solved tickets from the SupportHelpdesk project.
This is an admin function - only available to DEVELOPMENT users and above.
 * @request GET:/YouTrack/tickets/all
 * @secure
 */
    youTrackGetAllTickets: (
      query?: {
        /**
         * Maximum number of tickets to retrieve. Defaults to 100.
         * @format int32
         * @default 100
         */
        top?: number;
        /**
         * Number of tickets to skip for pagination. Defaults to 0.
         * @format int32
         * @default 0
         */
        skip?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<YouTrackIssueDTO[], ProblemDetails>({
        path: `/YouTrack/tickets/all`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags YouTrack
 * @name YouTrackGetTicketDetails
 * @summary Retrieves detailed information about a specific YouTrack ticket including description and public comments.
OFFICE users can optionally filter by email to check access.
 * @request GET:/YouTrack/tickets/{issueId}
 * @secure
 */
    youTrackGetTicketDetails: (
      issueId: string,
      query?: {
        /** Optional email to filter access check for (only for OFFICE users). */
        filterEmail?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<YouTrackIssueDetailDTO, ProblemDetails>({
        path: `/YouTrack/tickets/${issueId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags YouTrack
 * @name YouTrackIsReporter
 * @summary Checks if the currently authenticated user is the reporter of a specific ticket.
OFFICE users can optionally check for a different email.
 * @request GET:/YouTrack/tickets/{issueId}/is-reporter
 * @secure
 */
    youTrackIsReporter: (
      issueId: string,
      query?: {
        /** Optional email to check for (only for OFFICE users). */
        filterEmail?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/YouTrack/tickets/${issueId}/is-reporter`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags YouTrack
 * @name YouTrackCreateComment
 * @summary Creates a new comment on a YouTrack ticket on behalf of the currently authenticated user.
Only works if the user is the reporter of the ticket.
OFFICE users can optionally comment on behalf of a different email.
 * @request POST:/YouTrack/tickets/{issueId}/comments
 * @secure
 */
    youTrackCreateComment: (
      issueId: string,
      data: CreateCommentRequest,
      query?: {
        /** Optional email to comment on behalf of (only for OFFICE users). */
        filterEmail?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ProblemDetails | void>({
        path: `/YouTrack/tickets/${issueId}/comments`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
}
